$xhr = "";
$xhrCount = '';
$ajax_call_stone_list_running = "No";
$stoneTotal = $pageCount = 0;
var sliderObjArray = [];
// const API_URL = "/apps/ring-creator-custom/process_on_request.php";
const API_URL = "https://phpstack-1090158-5661194.cloudwaysapps.com/process_on_request.php";
const canvasId = 'webgl_vdb_canvas';
const three_d_static_data = [
    {
        "pmat": {
            "yellow_gold": "https://cdn.shopify.com/s/files/1/0772/7893/7366/files/PromiseYellow_3b402b1a-5459-4b27-9a7e-02b08b720562.pmat",
            "white_gold": "https://cdn.shopify.com/s/files/1/0772/7893/7366/files/PromiseWhite_f2a8de31-6587-457d-b897-4f90a4053274.pmat",
            "rose_gold": "https://cdn.shopify.com/s/files/1/0772/7893/7366/files/PromiseRose_7dbe1eb6-825b-4f78-8f80-fa297dc59152.pmat"
        },
        "dmat": {
            "asscher": "https://cdn.shopify.com/s/files/1/0772/7893/7366/files/asscher.dmat",
            "cushion": "https://cdn.shopify.com/s/files/1/0772/7893/7366/files/cushion.dmat",
            "elongated-cushion": "https://cdn.shopify.com/s/files/1/0772/7893/7366/files/elongated-cushion.dmat",
            "emerald": "https://cdn.shopify.com/s/files/1/0772/7893/7366/files/emerald.dmat",
            "heart": "https://cdn.shopify.com/s/files/1/0772/7893/7366/files/Promise.dmat",
            "marquise": "https://cdn.shopify.com/s/files/1/0772/7893/7366/files/marquise.dmat",
            "oval": "https://cdn.shopify.com/s/files/1/0772/7893/7366/files/oval.dmat?v=1741371964",
            "pear": "https://cdn.shopify.com/s/files/1/0772/7893/7366/files/pear.dmat",
            "princess": "https://cdn.shopify.com/s/files/1/0772/7893/7366/files/princess.dmat",
            "radiant": "https://cdn.shopify.com/s/files/1/0772/7893/7366/files/asscher.dmat",
            "round": "https://cdn.shopify.com/s/files/1/0772/7893/7366/files/round.dmat"
        },
        "vjson": "https://cdn.shopify.com/s/files/1/0772/7893/7366/files/EffyPromise_4855a47d-158d-40fb-9f15-270662ef78f3.vjson",
    }
];

setTimeout(function () {
    $("#vdbrb_main_page_cover").fadeOut(200);
    // $("#vdbrb_filter_block_loader").fadeOut(200);
}, 5000);
$(window).on("load", function () {
    $("#vdbrb_main_page_cover").fadeOut(200);
    // $("#vdbrb_filter_block_loader").fadeOut(200);
});

function debounce(func, wait) {
    let timeout;
    return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}

$(window).on("scroll", debounce(function () {
    const scrollPosition = $(this).scrollTop();
    const hasScrolled = scrollPosition > 50;

    $(".vdb-header_wrapper").toggleClass("sticky", hasScrolled);
    // $(".vdb-sidemenu-wrapper").toggleClass("collapsed", hasScrolled);
}, 100));

$(document).ready(async function () {

    if (isMobileDevice()) {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        $('body').addClass('vdbrc_is_mobile_device');

        if (/android/i.test(userAgent)) {
            $('body').addClass('is-android');
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            $('body').addClass('is-ios');
        } else {
            console.log('Neither Android nor iOS');
        }
    }

    await fetchData();

    //#region : On Load Process Based On Step
    let params = new URLSearchParams(window.location.search);
    if (!params.has("step")) {
        $("#vdbrb_design_ring_module").removeClass("d-none");
        $("#vdbrb_design_ring_process").addClass("active");
        let pushstate_string = updateUrl(window.top.location.href, "step", "design_ring");
        window.top.history.pushState({}, "", pushstate_string);
        resetStoneFilter(true);
        resetDeepLink();
    } else {
        let step = params.get("step");
        if (step == "design_ring") {
            $("#vdbrb_design_ring_module").removeClass("d-none");
            $("#vdbrb_design_ring_process").addClass("active");
            let pushstate_string = updateUrl(window.top.location.href, "step", "design_ring");
            window.top.history.pushState({}, "", pushstate_string);
            resetStoneFilter(true);
            resetDeepLink();
        } else if (step == "select_diamond") {
            $("#vdbrb_select_diamond_module").removeClass("d-none");
            $("#vdbrb_select_diamond_process").addClass("active");
            $("#vdbrb_design_ring_process").addClass("selected");
            $(".vdbrb_exclude_price_text").addClass("d-none");
            $(".vdbrb_header_price").removeClass("d-none");

            deepLinkStone();
            set_default_module_by_cookie_labgrown();
            await call_stone_again();

            scrollTillSelectedDiamond();
        } else if (step == "review") {
            $("#vdbrb_design_ring_module").removeClass("d-none");

            $("#vdbrb_review_process").addClass("active").addClass("selected");
            // $("#vdbrb_design_ring_process_start_over").addClass("selected");
            // $("#vdbrb_design_ring_process_start_over svg path").css("fill", "#a7c2c1");

            $("#vdbrb_design_ring_process").addClass("selected");
            $("#vdbrb_select_diamond_process").addClass("selected");
            $(".vdbrb_exclude_price_text").addClass("d-none");
            // $(".vdbrb_header_price").addClass("d-none");
            $(".vdbrb_ring_detail_link").removeClass("d-none");

            handleReviewPageBlock('show');

            deepLinkStone();
            set_default_module_by_cookie_labgrown();
            let params = new URLSearchParams(window.location.search);
            let diamond_stock_num = params.has("diamond_stock_num") ? params.get("diamond_stock_num") : "";
            await call_labgrown_list(diamond_stock_num);
        }
    }
    //#endregion

    var swiper = new Swiper(".mySwiper", {
        slidesPerView: 3,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        grid: {
            rows: 2,
        },
        spaceBetween: 8,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            "@1.00": {
                slidesPerView: 3,
                spaceBetween: 8,

            },
        },
    });
    //  Find a Wedding Band Details Popup
    var swiper = new Swiper(".vdb-band-details", {
        pagination: {
            el: ".swiper-pagination",
        },
    });

    //#region : Custom Range Slider
    let objVbdrbCaratFromSliderLabgrownWeb = new customRangeSlider("vbdrb_carat_from_slider_labgrown_web", "vbdrb_carat_to_slider_labgrown_web", "vbdrb_carat_from_slider_input_labgrown_web", "vbdrb_carat_to_slider_input_labgrown_web", null, null, false, (from, to) => {
        var from_value = parseFloat(from).toFixed(2);
        var to_value = parseFloat(to).toFixed(2);
        $(".vdbrb_min_carat_labgrown_web").val(from_value);
        $(".vdbrb_max_carat_labgrown_web").val(to_value);
        document.cookie = "vdbrb_labgrown_min_carat=" + from_value;
        document.cookie = "vdbrb_labgrown_max_carat=" + to_value;

        applyFilter();
    });
    sliderObjArray.push(objVbdrbCaratFromSliderLabgrownWeb);
    let objVbdrbPriceFromSliderLabgrownWeb = new customRangeSlider("vbdrb_price_from_slider_labgrown_web", "vbdrb_price_to_slider_labgrown_web", "vbdrb_price_from_slider_input_labgrown_web", "vbdrb_price_to_slider_input_labgrown_web", null, null, false, (from, to) => {
        var from_value = parseFloat(from).toFixed(2);
        var to_value = parseFloat(to).toFixed(2);
        $(".vdbrb_min_price_labgrown_web").val(from_value);
        $(".vdbrb_max_price_labgrown_web").val(to_value);
        document.cookie = "vdbrb_labgrown_min_price=" + from_value;
        document.cookie = "vdbrb_labgrown_max_price=" + to_value;

        applyFilter();
    });
    sliderObjArray.push(objVbdrbPriceFromSliderLabgrownWeb);
    let objVbdrbWhiteColorFromSliderLabgrownWeb = new customRangeSlider("vbdrb_white_color_from_slider_labgrown_web", "vbdrb_white_color_to_slider_labgrown_web", "vbdrb_white_color_from_slider_input_labgrown_web", "vbdrb_white_color_to_slider_input_labgrown_web", null, null, true, (from, to) => {
        var from_value = labgrownColorArray[from];
        var to_value = labgrownColorArray[to];
        var full_value = from_value + "," + to_value;
        document.cookie = "vdbrb_labgrown_color_white=" + full_value;

        applyFilter();
    });
    sliderObjArray.push(objVbdrbWhiteColorFromSliderLabgrownWeb);
    let objVbdrbClarityFromSliderLabgrownWeb = new customRangeSlider("vbdrb_clarity_from_slider_labgrown_web", "vbdrb_clarity_to_slider_labgrown_web", "vbdrb_clarity_from_slider_input_labgrown_web", "vbdrb_clarity_to_slider_input_labgrown_web", null, null, true, (from, to) => {
        var from_value = labgrownClarityArray[from];
        var to_value = labgrownClarityArray[to];
        var full_value = from_value + "," + to_value;
        document.cookie = "vdbrb_labgrown_clarity=" + full_value;

        applyFilter();
    });
    sliderObjArray.push(objVbdrbClarityFromSliderLabgrownWeb);
    let objVbdrbCaratFromSliderLabgrownMobile = new customRangeSlider("vbdrb_carat_from_slider_labgrown_mobile", "vbdrb_carat_to_slider_labgrown_mobile", "vbdrb_carat_from_slider_input_labgrown_web", "vbdrb_carat_to_slider_input_labgrown_web", null, null, false, (from, to) => {
        var from_value = parseFloat(from).toFixed(2);
        var to_value = parseFloat(to).toFixed(2);
        $(".vdbrb_min_carat_labgrown_web").val(from_value);
        $(".vdbrb_max_carat_labgrown_web").val(to_value);
        document.cookie = "vdbrb_labgrown_min_carat=" + from_value;
        document.cookie = "vdbrb_labgrown_max_carat=" + to_value;

        applyFilter();
    });
    sliderObjArray.push(objVbdrbCaratFromSliderLabgrownMobile);
    let objVbdrbPriceFromSliderLabgrownMobile = new customRangeSlider("vbdrb_price_from_slider_labgrown_mobile", "vbdrb_price_to_slider_labgrown_mobile", "vbdrb_price_from_slider_input_labgrown_web", "vbdrb_price_to_slider_input_labgrown_web", null, null, false, (from, to) => {
        var from_value = parseFloat(from).toFixed(2);
        var to_value = parseFloat(to).toFixed(2);
        $(".vdbrb_min_price_labgrown_web").val(from_value);
        $(".vdbrb_max_price_labgrown_web").val(to_value);
        document.cookie = "vdbrb_labgrown_min_price=" + from_value;
        document.cookie = "vdbrb_labgrown_max_price=" + to_value;

        applyFilter();
    });
    sliderObjArray.push(objVbdrbPriceFromSliderLabgrownMobile);
    let objVbdrbWhiteColorFromSliderLabgrownMobile = new customRangeSlider("vbdrb_white_color_from_slider_labgrown_mobile", "vbdrb_white_color_to_slider_labgrown_mobile", "vbdrb_white_color_from_slider_input_labgrown_web", "vbdrb_white_color_to_slider_input_labgrown_web", null, null, true, (from, to) => {
        var from_value = labgrownColorArray[from];
        var to_value = labgrownColorArray[to];
        var full_value = from_value + "," + to_value;
        document.cookie = "vdbrb_labgrown_color_white=" + full_value;

        applyFilter();
    });
    sliderObjArray.push(objVbdrbWhiteColorFromSliderLabgrownMobile);
    let objVbdrbClarityFromSliderLabgrownMobile = new customRangeSlider("vbdrb_clarity_from_slider_labgrown_mobile", "vbdrb_clarity_to_slider_labgrown_mobile", "vbdrb_clarity_from_slider_input_labgrown_web", "vbdrb_clarity_to_slider_input_labgrown_web", null, null, true, (from, to) => {
        var from_value = labgrownClarityArray[from];
        var to_value = labgrownClarityArray[to];
        var full_value = from_value + "," + to_value;
        document.cookie = "vdbrb_labgrown_clarity=" + full_value;

        applyFilter();
    });
    sliderObjArray.push(objVbdrbClarityFromSliderLabgrownMobile);
    //#endregion

    //#region : Open Get Inspired Modal On load
    const isGetInspiredModalDisplayed = getCookie("vdbrb_is_get_inspired_modal_displayed");
    if (!isGetInspiredModalDisplayed) {
        setTimeout(function () {
            $("#vdb-get-inspired-btn").trigger("click");
            const date = new Date();
            date.setTime(date.getTime() + 1 * 60 * 60 * 1000); // 1 hour expiry
            const expires = "; expires=" + date.toUTCString();
            document.cookie = "vdbrb_is_get_inspired_modal_displayed=true" + expires + "; path=/";
        }, 5000);
    }
    //#endregion

    let diamond_stock_num = params.has("diamond_stock_num") ? params.get("diamond_stock_num") : "";
    if (params.has("step") && params.get("step") == 'select_diamond') {
        $("#vdbrb_setting_option_tab .vdb-step").removeClass("vdb-step-active");
        $('.vdb-step[data-step="diamond_selection"]').first().addClass("vdb-step-active");

        if(diamond_stock_num){
            $(`.vdbrc_select_stone_checkbox[data-stock-num="${diamond_stock_num}"]`).trigger('click');

            $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_review_btn').removeClass("d-none");
            $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_atc_btn').addClass("d-none");
            $('#vdbrb_setting_option_tab .vdb-next-btn').addClass("text_btn");
        }
    }
    console.log(params.has("step") && params.get("step") == 'review');
    if (params.has("step") && params.get("step") == 'review') {
        $('#vdbrb_setting_option_tab .vdb-step').removeClass("vdb-step-active");
        $('#vdbrb_setting_option_tab .vdb-step[data-step="review"]').removeClass("d-none").addClass("vdb-step-active");

        console.log(diamond_stock_num);

        $(`.vdbrc_select_stone_checkbox[data-stock-num="${diamond_stock_num}"]`).trigger('click');
        $(`.vdbrb_select_diamond[data-stock-num="${diamond_stock_num}"]`).trigger('click');

        $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_review_btn').addClass("d-none");
        $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_atc_btn').removeClass("d-none");
        $('#vdbrb_setting_option_tab .vdb-next-btn').addClass("text_btn");

        bindRingDetailsModalHtml();
    }
    updateArrows();
    /* if (params.has("step") && params.get("step") == 'design_ring') {
        $("#vdbrb_setting_option_tab").find("[data-main-option-group-slug]").first().trigger("click");
    } */

    const default_ring_size = "7.00";
    document.cookie = `vdbrb_ring_size=${default_ring_size}`;
});
$(document).on("click", function (event) {
    const $target = $(event.target);

    // Close filter if click is outside filter and toggle button
    if (!$target.closest(".vdb_mobile_drop_fitler, .vdb_mobile_view-list").length) {
        $(".vdb_mobile_drop_fitler").removeClass("filter_show");
    }

    // Handle closing modals if click is outside certain elements
    if ($('body').hasClass('vdb-modal-open') &&
        !$target.closest('.vdb-custom-modal .vdb-modal-content, #vdbrc-filter-your-search-btn, #vdbrc_specific_collection_popup_btn, #vdb-get-inspired-btn, .vdbrc_diamond_details_popup_btn, .vdbrc_flexible_payment_popup_btn, .vdbrb_hand_view, .vdbrb_save_process, .vdbrb_consult_an_expert, .vdbrb_ring_detail_link, .vdbrc_drop_hint_popup_btn,#vdbrb_select_diamond_popup').length) {

        $('.vdb-close').trigger('click');
    }
});

$("body").on("click", "#vdbrc-filter-your-search-btn", function (e) {
    $("#vdbrc-filter-your-search").addClass("vdb-open-popup");
    $("body").addClass("vdb-modal-open");
});
$("body").on("click", "#vdbrc_specific_collection_popup_btn", function (e) {
    $("#vdbrc_specific_collection_popup").addClass("vdb-open-popup");
    $("body").addClass("vdb-modal-open");
});

$("body").on("click", "#vdbrb_select_diamond_popup .vdb-close.vdb-button", function (e) {
    $("#vdbrb_select_diamond_popup").css({
        "opacity": "0",
        "pointer-events": "none",
        "visibility": "hidden"
    });
    
});

$("body").on("click", ".vdbrc_flexible_payment_popup_btn", function (e) {
    $("#vdbrc_flexible_payment_popup").addClass("vdb-open-popup");
    $("body").addClass("vdb-modal-open");
});

$("body").on("click", "#vdb-get-inspired-btn", function (e) {
    $("#vdbrc_get_inspired_popup").addClass("vdb-open-popup");
    $("body").addClass("vdb-modal-open");
    $('.vdbrc_get_inspired_slide').removeClass('selected');
    // $('#vdbrc_get_inspired_customize_btn').addClass('vdb-btn-disable');
});
$("body").on("click", ".vdbrc_get_inspired_slide", function () {
    $('.vdbrc_get_inspired_slide').removeClass('selected');
    $(this).addClass('selected');
    $('#vdbrc_get_inspired_customize_btn').removeClass('vdb-btn-disable');

    // Client Feedback
    let url = $(this).data('url');
    if (url) {
        window.location.href = url;
    }
});
$("body").on("click", "#vdbrc_get_inspired_customize_btn", function () {
    let url = $('.vdb-rc-find-details-slide.selected').data('url');
    if (url) {
        window.location.href = url;
    }
});

$("body").on("click", ".vdb_search_mobile_icon", function () {
    $(this).closest(".vdbrc_app_select_search_box_for_mobile").addClass("search_enable");
});
$("body").on("click", ".vdb_search_mobile_close", function () {
    $(this).closest(".vdbrc_app_select_search_box_for_mobile").removeClass("search_enable");
    $(".vdbrb_search_web_id_input").val("").trigger("change");
});
$("body").on("click", ".vdb-close,.vdbrc_back_to_ring_btn", function (e) {
    e.stopPropagation();
    e.preventDefault();
    const popupIds = ["#vdbrc_specific_collection_popup", "#vdbrc-filter-your-search", "#vdbrc_consult_expert_popup", "#vdbrc_save_progress_popup", "#vdbrc_drop_hint_popup", "#vdbrc_hand_view_popup", "#vdbrc_get_inspired_popup", "#vdbrc_weddding_details_popup", "#vdbrc_diamond_details_popup", "#vdbrc_flexible_payment_popup"];
    popupIds.forEach(function (id) {
        $(id).removeClass("vdb-open-popup");
    });
    $("body").removeClass("vdb-modal-open");
});

$("body").on("click", ".vdb-close-shape-warning-popup", function (e) {
    $("#vdbrc_shape_warning_block").hide();
});
$("body").on("click", ".vdb-proceed-shape-warning-popup", function (e) {
    $("#vdbrc_shape_warning_block").hide();
    $("#vdbrc_shape_warning_block").attr('data-is-allowed', true);
});


$("body").on("click", ".vdbrb_list_item_shape_labgrown", function () {
    var api_value = $(this).data("api-value");
    $(".vdbrb_list_item_shape_labgrown").each(function () {
        $(this).removeClass("vdb-shape-select-stone");
    });
    $(this).toggleClass("vdb-shape-select-stone");
    document.cookie = "vdbrb_labgrown_shape_style=" + api_value;

    $(`#vdbrb_setting_option_tab_data .vdbrc_setting_attr_opt[data-main-option-slug="stone_shape"][data-value="${api_value}"]`).trigger('click');

    applyFilter();
});
$("body").on("change", ".vdbrb_min_carat_labgrown_web", function () {
    var vdbrb_max_carat_labgrown_web = parseFloat($(".vdbrb_max_carat_labgrown_web").val().trim()).toFixed(2);
    var _this = $(this);
    var v = parseFloat($(this).val().trim());
    if (v > vdbrb_max_carat_labgrown_web) {
        v = vdbrb_max_carat_labgrown_web;
    } else if (v < default_min_carat_labgrown) {
        v = default_min_carat_labgrown;
    } else if (v > default_max_carat_labgrown) {
        v = default_max_carat_labgrown;
    }
    v = parseFloat(v).toFixed(2);
    if (isNaN(v)) {
        v = default_min_carat_labgrown;
    }
    $(".vdbrb_min_carat_labgrown_web").val(v);
    document.cookie = "vdbrb_labgrown_min_carat=" + v;
    document.cookie = "vdbrb_labgrown_max_carat=" + vdbrb_max_carat_labgrown_web;

    applyFilter();
});
$("body").on("change", ".vdbrb_max_carat_labgrown_web", function () {
    var vdbrb_min_carat_labgrown_web = parseFloat($(".vdbrb_min_carat_labgrown_web").val().trim()).toFixed(2);
    var _this = $(this);
    var v = parseFloat($(this).val().trim());
    if (v < vdbrb_min_carat_labgrown_web) {
        v = vdbrb_min_carat_labgrown_web;
    } else if (v < default_min_carat_labgrown) {
        v = default_min_carat_labgrown;
    } else if (v > default_max_carat_labgrown) {
        v = default_max_carat_labgrown;
    }
    v = parseFloat(v).toFixed(2);
    if (isNaN(v)) {
        v = default_max_carat_labgrown;
    }
    $(".vdbrb_max_carat_labgrown_web").val(v);
    document.cookie = "vdbrb_labgrown_max_carat=" + v;
    document.cookie = "vdbrb_labgrown_min_carat=" + vdbrb_min_carat_labgrown_web;

    applyFilter();
});
$("body").on("change", ".vdbrb_min_price_labgrown_web", function () {
    var vdbrb_max_price_labgrown_web = parseFloat($(".vdbrb_max_price_labgrown_web").val().trim()).toFixed(2);
    var _this = $(this);
    var v = parseFloat($(this).val().trim());
    if (v > vdbrb_max_price_labgrown_web) {
        v = vdbrb_max_price_labgrown_web;
    } else if (v < default_min_price_labgrown) {
        v = default_min_price_labgrown;
    } else if (v > default_max_price_labgrown) {
        v = default_max_price_labgrown;
    }
    v = parseFloat(v).toFixed(2);
    if (isNaN(v)) {
        v = default_min_price_labgrown;
    }
    $(".vdbrb_min_price_labgrown_web").val(v);
    document.cookie = "vdbrb_labgrown_min_price=" + v;
    document.cookie = "vdbrb_labgrown_max_price=" + vdbrb_max_price_labgrown_web;

    applyFilter();
});
$("body").on("change", ".vdbrb_max_price_labgrown_web", function () {
    var vdbrb_min_price_labgrown_web = parseFloat($(".vdbrb_min_price_labgrown_web").val().trim()).toFixed(2);
    var _this = $(this);
    var v = parseFloat($(this).val().trim());
    if (v < vdbrb_min_price_labgrown_web) {
        v = vdbrb_min_price_labgrown_web;
    } else if (v < default_min_price_labgrown) {
        v = default_min_price_labgrown;
    } else if (v > default_max_price_labgrown) {
        v = default_max_price_labgrown;
    }
    v = parseFloat(v).toFixed(2);
    if (isNaN(v)) {
        v = default_max_price_labgrown;
    }
    $(".vdbrb_max_price_labgrown_web").val(v);
    document.cookie = "vdbrb_labgrown_max_price=" + v;
    document.cookie = "vdbrb_labgrown_min_price=" + vdbrb_min_price_labgrown_web;

    applyFilter();
});
$("body").on("click", ".continue_diamond_section", async function () {
    if ($(this).hasClass("vdb-step-active")) {
        return;
    }

    const activeTabStep = $("#vdbrb_setting_option_tab .vdb-step.vdb-step-active").attr("data-step");
    $('body').removeClass('setting_option diamond_selection review').addClass(activeTabStep);

    if (activeTabStep == 'diamond_selection') {
        let checkedBox = $('.vdbrc_select_stone_checkbox:checked');
        if (checkedBox.length == 0) {
            $("#vdbrb_select_diamond_popup").css({
                "opacity": "1",
                "pointer-events": "all"
            });
            $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_atc_btn').addClass("d-none");
            $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_review_btn').addClass("d-none");
            $('#vdbrb_setting_option_tab .vdb-next-btn').removeClass("text_btn"); 
            return;
        }
    }

    let selecteddSettingShape = $('.lineitem_prop[data-main-option-slug="stone_shape"]').val();
    if ($(`.vdbrb_list_item_shape_labgrown[data-api-value="${selecteddSettingShape}"]`).length > 0) {
        document.cookie = `vdbrb_labgrown_shape_style=${selecteddSettingShape}`;
        $(`.vdbrb_list_item_shape_labgrown`).removeClass("vdb-shape-select-stone");
        $(`.vdbrb_list_item_shape_labgrown[data-api-value="${selecteddSettingShape}"]`).addClass("vdb-shape-select-stone");
    }

    document.cookie = "vdbrb_labgrown_sorting=Lowest Price";
    $("#vdbrb_sort_dropdown").val("Lowest Price");
    $(".vdb_mobile_drop_fitler").find(`div[data-value="Lowest Price"]`).addClass("active");

    $("#vdbrb_design_ring_module").addClass("d-none");
    $("#vdbrb_design_ring_process").removeClass("active").addClass("selected");
    $("#vdbrb_select_diamond_module").removeClass("d-none");
    $("#vdbrb_select_diamond_process").addClass("active");

    const pushstate_string = updateUrl(window.top.location.href, "step", "select_diamond");
    window.top.history.pushState({}, "", pushstate_string);

    let params = new URLSearchParams(window.location.search);
    if (!params.has("diamond_stock_num")) {
        await call_stone_again();
    }

    if (isMobileDevice()) {
        const elem = $('#vdbrb_stone_list_view_block');
        if (elem.length) {
            $('html, body').animate({
                scrollTop: elem.offset().top - 130
            }, 100);
        }
    } else {
        $("html, body").scrollTop(0);
    }
    
    if (params.has("diamond_stock_num")) {
        scrollTillSelectedDiamond();

        $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_atc_btn').addClass("d-none");
        $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_review_btn').removeClass("d-none");
        $('#vdbrb_setting_option_tab .vdb-next-btn').addClass("text_btn");
    }

    // $('body').addClass('vdbrc_is_mobile_device');
});
$("body").on("click", "#vdbrb_reset_filter, #vdbrb_reset_filter_mobile", async function () {
    resetStoneFilter();
    resetDeepLink();
    $("#vdbrb_review_process").removeClass("active").removeClass("selected");
    $(".vdbrb_exclude_price_text").removeClass("d-none");
    $(".vdbrb_header_price").removeClass("d-none");
    $(".vdbrb_ring_detail_link").addClass("d-none");
    await call_stone_again();
});
$("body").on("click", "#apply_filter, #apply_filter_mobile", async function () {
    await call_stone_again();
    // $("#vdbrc-filter-your-search").removeClass("vdb-open-popup");
    // $("body").removeClass("vdb-modal-open");
});
async function applyFilter() {
    await call_stone_again();
    // $("#vdbrc-filter-your-search").removeClass("vdb-open-popup");
    // $("body").removeClass("vdb-modal-open");
}
$("body").on("click", ".vdb_mobile_drop_fitler > div", async function () {
    let value = $(this).data("value");
    document.cookie = "vdbrb_labgrown_sorting=" + value;
    $(".vdb_mobile_drop_fitler > div").removeClass("active");
    $(this).addClass("active");
    await call_stone_again();
});
$("body").on("change", "#vdbrb_sort_dropdown", async function () {
    let value = $(this).val();
    document.cookie = "vdbrb_labgrown_sorting=" + value;
    await call_stone_again();
});
$("body").on("click", ".vdbrb_pagination_link", async function () {
    var page_number = $(this).data("current_page");
    $("#vdbrb_labgrown_page_number").val(page_number);
    document.cookie = "vdbrb_labgrown_page_number=" + page_number;
    await call_labgrown_list();
});
$("body").on("click", ".vdb_rb_list_row", function () {
    let parentDiv = $(this).closest(".vdb_rb_list_row_tr");
    let isActive = parentDiv.hasClass("vdb_gd_data_tr_active");

    $(".vdb_rb_list_row_tr").removeClass("vdb_gd_data_tr_active");
    $(".vdbrb_diamond_more_details").hide();

    // Stop all videos before removing src
    $("video.vdb_stone_video").each(function () {
        this.pause();
        $(this).attr("src", "");
    });

    // Clear all iframe src
    $(".vdbrb_diamond_more_details iframe").attr("src", "");

    if (!isActive) {
        parentDiv.find(".vdbrb_diamond_more_details").show();
        parentDiv.addClass("vdb_gd_data_tr_active");

        let videoUrl = parentDiv.attr("data-video-url");
        let imageUrl = parentDiv.attr("data-image-url") || no_image_url;

        if (videoUrl) {
            // Handle video tag
            let videoTag = parentDiv.find("video.vdb_stone_video");
            if (videoTag.length > 0) {
                videoTag.attr("src", videoUrl);
                videoTag.show(); // Ensure video is visible
                videoTag.get(0).play();
            }

            // Handle iframe
            let iframeTag = parentDiv.find("iframe");
            if (iframeTag.length > 0) {
                iframeTag.attr("src", videoUrl);
                iframeTag.show();
            }

            // Hide image if video is available
            parentDiv.find(".vdbrb_stone_img").hide();
        } else if (imageUrl) {
            // Handle image display
            let imageTag = parentDiv.find(".vdbrb_stone_img");
            if (imageTag.length > 0) {
                imageTag.attr("src", imageUrl);
                imageTag.show();
            }

            // Hide video and iframe if image is used
            parentDiv.find("video.vdb_stone_video, iframe").hide();
        }
    }

    /* if ($(this).closest(".vdb_rb_list_row_tr").hasClass("vdb_gd_data_tr_active")) {
        $(".vdb_rb_list_row_tr").removeClass("vdb_gd_data_tr_active");
        $('.vdbrb_diamond_more_details').hide();
    } else {
        $(".vdb_rb_list_row_tr").removeClass("vdb_gd_data_tr_active");
        $('.vdbrb_diamond_more_details').hide();

        let parentDiv = $(this).closest(".vdb_rb_list_row_tr");
        parentDiv.find(".vdbrb_diamond_more_details").toggle();
        parentDiv.toggleClass("vdb_gd_data_tr_active");

        // Check if the video exists before playing
        let video = parentDiv.find(".vdbrb_diamond_more_details video.vdb_stone_video").get(0);
        if (video) {
            video.play();
        }
    } */

});

$("body").on("click", ".vdbrc_app_select_item_wrap", async function () {
    let filterType = $(this).data("filter-type");
    if (filterType == "shape") {
        document.cookie = "vdbrb_labgrown_shape_style=";
        if ($(".vdbrb_list_item_shape_labgrown").length > 0) {
            $(".vdbrb_list_item_shape_labgrown").each(function () {
                $(this).removeClass("vdb-shape-select-stone");
            });
        }
    } else if (filterType == "color") {
        document.cookie = "vdbrb_labgrown_color_white=";
        resetSpecificSlider("color");
    } else if (filterType == "price") {
        document.cookie = "vdbrb_labgrown_min_price=";
        document.cookie = "vdbrb_labgrown_max_price=";
        resetSpecificSlider("price");
    } else if (filterType == "carat") {
        document.cookie = "vdbrb_labgrown_min_carat=";
        document.cookie = "vdbrb_labgrown_max_carat=";
        resetSpecificSlider("carat");
    } else if (filterType == "clarity") {
        document.cookie = "vdbrb_labgrown_clarity=";
        resetSpecificSlider("clarity");
    }
    $(`.vdbrc_app_select_item_wrap[data-filter-type="${filterType}"]`).remove();
    await call_stone_again();
});
$("body").on("click", ".vdbrc_diamond_details_popup_btn", async function () {
    let stock_num = $(this).data("stock-num");
    let stoneData = $(`#vdbrc_diamond_details_${stock_num}`).text();
    await bindDiamondDetailPopup(stoneData);
    setTimeout(function () {
        let iframeElem = $("#vdbrc_diamond_details_popup iframe");
        if (iframeElem) {
            iframeElem.attr("src", iframeElem.attr("data-src"));
        }
        $("#vdbrc_diamond_details_popup").addClass("vdb-open-popup");
        $("body").addClass("vdb-modal-open");
    }, 1000);
});
$("body").on("click", ".vdbrb_search_web_id_btn", async function () {
    let stock_num = $(".vdbrb_search_web_id_input").val();
    $("#vdbrb_labgrown_page_number").val("1");
    await call_labgrown_list(stock_num);
});
$("body").on("click", ".vdbrb_download_video", async function () {
    let video_url = $(this).data("video-url");
    window.open(video_url, "_blank");
});
$("body").on("change", "#vdbrb_view_dropdown", function () {
    const view_type = $(this).val();
    $("#vdbrb_stone_list_view_block").toggle(view_type === "LIST_VIEW");
    $("#vdbrb_stone_grid_view_block").toggle(view_type === "GRID_VIEW");

    let checkedBox = $('.vdbrc_select_stone_checkbox:checked');
    
    if (view_type === "GRID_VIEW") {
        $("#vdbrb_stone_grid_view_block img.vdbrb_stone_grid_thumbnail").each(function () {
            const imgTag = $(this);
            const dataSrc = imgTag.attr("data-src");

            if (dataSrc) {
                imgTag.attr("src", dataSrc).show(); // Load image if not set
            }
        });
        $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_atc_btn').addClass("d-none");
        $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_review_btn').addClass("d-none");
        $('#vdbrb_setting_option_tab .vdb-next-btn').removeClass("text_btn");
    }else if (checkedBox.length == 0) {
        $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_atc_btn').addClass("d-none");
        $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_review_btn').addClass("d-none");
        $('#vdbrb_setting_option_tab .vdb-next-btn').removeClass("text_btn"); 
    }else{
        $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_atc_btn').addClass("d-none");
        $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_review_btn').removeClass("d-none");
        $('#vdbrb_setting_option_tab .vdb-next-btn').addClass("text_btn");
    }
});
$("body").on("click", ".vdbrb_select_diamond", async function () {
    const stock_num = $(this).data("stock-num");
    let pushstate_string = window.top.location.href;
    pushstate_string = updateUrl(pushstate_string, "diamond_stock_num", stock_num);
    pushstate_string = updateUrl(pushstate_string, "step", "review");
    top.window.history.pushState({}, "", pushstate_string);

    $(`.vdbrc_select_stone_checkbox[data-stock-num="${stock_num}"]`).trigger('click');
    $("#vdbrb_select_diamond_module").addClass("d-none");
    $("#vdbrb_select_diamond_process").removeClass("active").addClass("selected");

    handleReviewPageBlock('show');
    $("#vdbrb_review_process").addClass("active").addClass("selected");
    // $("#vdbrb_design_ring_process_start_over").addClass("selected");
    // $("#vdbrb_design_ring_process_start_over svg path").css("fill", "#a7c2c1");

    $("#vdbrc_diamond_details_popup").removeClass("vdb-open-popup");
    $("body").removeClass("vdb-modal-open");

    updateArrows();
    
    let stoneData = $(`#vdbrc_diamond_details_${stock_num}`).text();
    const stone = JSON.parse(stoneData);
    if (Object.keys(stone).length > 0) {
        const total_sales_price = stone["total_sales_price"];
        const stone_currency_code = stone["currency_code"] ? stone["currency_code"] : "USD";
        const setting_price = $("#vdbrb_setting_hdn_prod_var_price").val();
        let total_price = Number(setting_price) / 100 + Number(total_sales_price);
        total_price = handlePriceData(stone_currency_code, total_price);
        $(".vdbrb_total_price").text(total_price);
        $(".vdbrb_exclude_price_text").addClass("d-none");
        $(".vdbrb_ring_detail_link").removeClass("d-none");
    }
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });

    bindRingDetailsModalHtml();

    // As per last client feedback we will not show the ring detail modal on load
    /* setTimeout(function () {
        $(".vdbrb_ring_detail_link").trigger("click");
    }, 1000); */

    // $(".vdbrb_header_price").addClass("d-none");

    await getStoneDataForAtc();
});
$("body").on("click", ".vdbrb_hand_view", async function (e) {
    console.log('Hand View');
    e.preventDefault();
    await loadHandViewIframe();
    $("#vdbrc_hand_view_popup").addClass("vdb-open-popup");
    $("body").addClass("vdb-modal-open");
});
$("body").on("change", ".vdbrc_select_stone_checkbox", async function () {
    $('.vdbrc_select_stone_checkbox').not(this).prop('checked', false);

    let checkedBox = $('.vdbrc_select_stone_checkbox:checked');
    if (checkedBox.length == 0) {
        $('#vdbrb_setting_option_tab .vdb-step[data-step="review"]').addClass("d-none").removeClass("vdb-step-active");
        
        $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_review_btn').addClass("d-none");
        $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_atc_btn').addClass("d-none");
        $('#vdbrb_setting_option_tab .vdb-next-btn').removeClass("text_btn");

        let newUrl = removeURLParameters(window.top.location.href, "diamond_stock_num");
        top.window.history.pushState({}, "", newUrl);
    }else {
        $('#vdbrb_setting_option_tab .vdb-step[data-step="review"]').removeClass("d-none").addClass("vdb-step-active");
        
        $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_review_btn').removeClass("d-none");
        $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_atc_btn').addClass("d-none");
        $('#vdbrb_setting_option_tab .vdb-next-btn').addClass("text_btn");
    }

    $("#vdbrb_select_diamond_popup").css("opacity", "0");
});

//#region : Save Process OR Share Product
$("body").on("click", ".vdbrb_save_process", function () {
    $("#vdbrb_save_process_email").html("");
    $("#vdbrb_save_process_email_error").val("");
    $('.save_process_msg').text('');
    $('#vdbrb_save_process_email').val('');
    $("#vdbrc_save_progress_popup").addClass("vdb-open-popup");
    $("body").addClass("vdb-modal-open");
});
$("body").on("click", "#vdbrb_save_process_copy_link_btn", function (e) {
    e.preventDefault();
    const url = window.location.href;
    const processMsg = $('.save_process_msg');
    processMsg.text('');
    copyToClipboard(url).then((success) => {
        let email = $('#vdbrb_save_process_email').val();
        let msg = 'The link has been copied to your clipboard!'
        processMsg.text(msg);
    });
});
$("body").on("input", "#vdbrb_save_process_email", function () {
    const value = $(this).val();
    $("#vdbrb_save_process_modal_submit_btn").toggleClass("vdb-btn-disable", value === "");
});
$("body").on("click", "#vdbrb_save_process_modal_submit_btn", async function () {
    const button = $(this);
    const emailVal = $("#vdbrb_save_process_email").val().trim();
    const emailErrorElement = $("#vdbrb_save_process_email_error");
    emailErrorElement.html("");
    if (!emailVal) {
        emailErrorElement.html("Email Address is required.");
        return;
    }
    const emailArr = emailVal.split(",");
    const isValid = emailArr.every((email) => validateEmail(email.trim()));
    if (!isValid) {
        emailErrorElement.html("Enter valid email address");
        return;
    }
    const originalText = button.text();
    button.text("Processing...");
    const dataVal = {
        action: "save_process",
        shop: shop,
        email_val: emailVal,
        share_url: btoa(window.location.href),
        prod_img: $("#vdbrb_setting_hdn_prod_img").val()
    };
    try {
        await fetch(API_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(dataVal),
        });
        button.text(originalText);
        $('.save_process_msg').text('A link has been sent to your email.');
        // $('.save_process_msg').text('An email with a link has been sent to your email!');

        setTimeout(() => {
            $("#vdbrc_save_progress_popup").removeClass("vdb-open-popup");
            $("body").removeClass("vdb-modal-open");
            $("#vdbrb_save_process_email").val("");
            $("#vdbrb_save_process_modal_submit_btn").addClass("vdb-btn-disable");
        }, 5000);
    } catch (error) {
        console.error("Failed to submit the data:", error);
    }
});
//#endregion

$("body").on("click", ".vdbrc_drop_hint_popup_btn", function () {
    $("#vdbrb_drop_a_hint_email").html("");
    $("#vdbrb_drop_a_hint_email_error").val("");
    $('.drop_a_hint_msg').text('');
    $('#vdbrb_drop_a_hint_email').val('');
    $("#vdbrc_drop_hint_popup").addClass("vdb-open-popup");
    $("body").addClass("vdb-modal-open");

    $("#vdbrc_weddding_details_popup").removeClass("vdb-open-popup");
    $("body").removeClass("vdb-modal-open");

    $("#vdbrc_drop_hint_popup").addClass("vdb-open-popup");
    $("body").addClass("vdb-modal-open");

});
$("body").on("click", "#vdbrb_drop_a_hint_copy_link_btn", function (e) {
    e.preventDefault();
    const url = window.location.href;
    const processMsg = $('.drop_a_hint_msg');
    processMsg.text('');
    copyToClipboard(url).then((success) => {
        let email = $('#vdbrb_drop_a_hint_email').val();
        let msg = 'The link has been copied to your clipboard.'
        processMsg.text(msg);
    });
});
$("body").on("input", "#vdbrb_drop_a_hint_email", function () {
    const value = $(this).val();
    $("#vdbrb_drop_a_hint_modal_submit_btn").toggleClass("vdb-btn-disable", value === "");
});
$("body").on("click", "#vdbrb_drop_a_hint_modal_submit_btn", async function () {
    const button = $(this);
    const emailVal = $("#vdbrb_drop_a_hint_email").val().trim();
    const emailErrorElement = $("#vdbrb_drop_a_hint_email_error");
    emailErrorElement.html("");
    if (!emailVal) {
        emailErrorElement.html("Email Address is required.");
        return;
    }
    const emailArr = emailVal.split(",");
    const isValid = emailArr.every((email) => validateEmail(email.trim()));
    if (!isValid) {
        emailErrorElement.html("Enter valid email address");
        return;
    }
    const originalText = button.text();
    button.text("Processing...");
    const dataVal = {
        action: "drop_a_hint",
        shop: shop,
        email_val: emailVal,
        share_url: btoa(window.location.href),
        prod_img: $("#vdbrb_setting_hdn_prod_img").val()
    };
    try {
        await fetch(API_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(dataVal),
        });
        button.text(originalText);
        $('.drop_a_hint_msg').text('A link has been sent to your email.');
        setTimeout(() => {
            ("#vdbrc_drop_hint_popup").removeClass("vdb-open-popup");
            $("body").removeClass("vdb-modal-open");
            $("#vdbrb_drop_a_hint_email").val("");
            $("#vdbrb_drop_a_hint_modal_submit_btn").addClass("vdb-btn-disable");
        }, 5000);
    } catch (error) {
        console.error("Failed to submit the data:", error);
    }
});

//#region : Consult An Expert
$("body").on("click", ".vdb_mobile_view-list", function () {
    $(".vdb_mobile_drop_fitler").toggleClass("filter_show");
});
$("body").on("click", ".vdbrb_consult_an_expert", function () {
    $("#vdbrc_consult_expert_name, #vdbrc_consult_expert_email, #vdbrc_consult_expert_query").val("");
    $("#vdbrc_consult_expert_popup").addClass("vdb-open-popup");
    $("body").addClass("vdb-modal-open");
});
$("body").on("input", "#vdbrc_consult_expert_name, #vdbrc_consult_expert_email, #vdbrc_consult_expert_query", function () {
    const expert_name = $("#vdbrc_consult_expert_name").val().trim();
    const expert_email = $("#vdbrc_consult_expert_email").val().trim();
    const expert_query = $("#vdbrc_consult_expert_query").val().trim();
    $("#vdbrc_consult_expert_modal_submit_btn").toggleClass("vdb-btn-disable", !(expert_name && expert_email && expert_query));
});
$("body").on("click", "#vdbrc_consult_expert_modal_submit_btn", async function () {
    const button = $(this);
    const emailVal = $("#vdbrc_consult_expert_email").val().trim();
    const nameVal = $("#vdbrc_consult_expert_name").val().trim();
    const queryVal = $("#vdbrc_consult_expert_query").val().trim();
    const emailErrorElement = $("#vdbrc_consult_expert_email_error").html("");
    const nameErrorElement = $("#vdbrc_consult_expert_name_error").html("");
    const queryErrorElement = $("#vdbrc_consult_expert_query_error").html("");
    if (!emailVal) {
        emailErrorElement.html("Email Address is required.");
        return;
    }
    if (!nameVal) {
        nameErrorElement.html("Name is required.");
        return;
    }
    if (!queryVal) {
        queryErrorElement.html("Query is required.");
        return;
    }
    const emailArr = emailVal.split(",");
    let isValid = true;
    emailArr.forEach((email) => {
        if (email && !validateEmail(email.trim())) {
            emailErrorElement.html("Enter Valid Email Address");
            isValid = false;
        }
    });
    if (!isValid) return;
    const originalText = button.text();
    button.text("Processing...");
    const dataVal = {
        action: "consult_expert",
        shop: shop,
        email_val: emailVal,
        cust_name: nameVal,
        cust_query: queryVal,
        setting_prod: $("#vdbrb_setting_hdn_prod_title").val(),
        setting_prod_id: $("#vdbrb_setting_hdn_prod_id").val(),
        share_url: btoa(window.location.href),
        prod_img: $("#vdbrb_setting_hdn_prod_img").val()
    };
    try {
        await fetch(API_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(dataVal),
        });
        button.text(originalText);
        $('.drop_a_hint_msg').text('Email Sent !');
        setTimeout(() => {
            $("#vdbrc_consult_expert_popup").removeClass("vdb-open-popup");
            $("body").removeClass("vdb-modal-open");
            $("#vdbrc_consult_expert_name, #vdbrc_consult_expert_email, #vdbrc_consult_expert_query").val("");
            $("#vdbrc_consult_expert_modal_submit_btn").addClass("vdb-btn-disable");
        }, 5000);
    } catch (error) {
        console.error("Failed to submit the data:", error);
    }
});
//#endregion

$("body").on("click", ".vdbrb_ring_detail_link", function (e) {
    $("#vdbrc_weddding_details_popup").addClass("vdb-open-popup");
    $("body").addClass("vdb-modal-open");
});
$("body").on("click", ".vdbrc_ring_detail_edit_btn", function (e) {
    let editedMainOption = $(this).data("main-option-group");
    $("#vdbrb_setting_option_tab").find(`[data-main-option-group="${editedMainOption}"]`).trigger("click");
    $("#vdbrb_design_ring_module").removeClass("d-none");
    $("#vdbrb_design_ring_process").addClass("active").addClass("selected");

    $("#vdbrb_review_module").addClass("d-none");
    $("#vdbrb_review_page_details_right_container").addClass("d-none");
    $("#vdbrb_design_ring_tab_filter_right_container").removeClass("d-none");

    $("#vdbrb_review_process").removeClass("active").removeClass("selected");
    $(".vdbrb_ring_detail_link").addClass("d-none");
    $("#vdbrc_weddding_details_popup").removeClass("vdb-open-popup");
    $("body").removeClass("vdb-modal-open");

    let params = new URLSearchParams(window.location.search);
    if (params.has("diamond_stock_num")) {
        $(".vdbrb_exclude_price_text").addClass("d-none");
        $(".vdbrb_header_price").removeClass("d-none");
    }

    const pushstate_string = updateUrl(window.top.location.href, "step", "design_ring");
    window.top.history.pushState({}, "", pushstate_string);

    update3DView();
    window.player.changeAutoRotate(false);
});
$("body").on("click", ".vdbrc_diamond_detail_edit_btn", function (e) {
    $('.continue_diamond_section').trigger('click');

    /* $("#vdbrb_review_module").addClass("d-none");
    $("#vdbrb_design_ring_module").addClass("d-none");

    $("#vdbrb_select_diamond_module").removeClass("d-none");
    $("#vdbrb_select_diamond_process").addClass("active").addClass("selected");

    $("#vdbrb_review_page_details_right_container").addClass("d-none");
    $("#vdbrb_design_ring_tab_filter_right_container").removeClass("d-none");

    $("#vdbrb_review_process").removeClass("active").removeClass("selected");
    $(".vdbrb_ring_detail_link").addClass("d-none");
    $("#vdbrc_weddding_details_popup").removeClass("vdb-open-popup");
    $("body").removeClass("vdb-modal-open");

    let params = new URLSearchParams(window.location.search);
    if (params.has("diamond_stock_num")) {
        $(".vdbrb_exclude_price_text").addClass("d-none");
        $(".vdbrb_header_price").removeClass("d-none");
    }

    const pushstate_string = updateUrl(window.top.location.href, "step", "select_diamond");
    window.top.history.pushState({}, "", pushstate_string);

    scrollTillSelectedDiamond(); */
});
$("body").on("click", ".vdbrb_step", function () {
    let step = $(this).attr("data-step");
    if ($(this).hasClass("selected")) {
        handleStepContainer(step);
    }
    if (!$(this).hasClass("selected") && step === 'select_diamond') {
        $('.continue_diamond_section').trigger('click');

        scrollTillSelectedDiamond();
    }
});

//#region : Add To Cart Process
$("body").on("click", ".vdbrb_add_to_cart_btn", async function () {
    let isAllAvalilable = true;
    if (isAllAvalilable) {
        const ring_size = getCookie("vdbrb_ring_size");
        if (ring_size == null || ring_size =='') {
            alert("Please select ring size");
            return false;
        }

        const atcLoader = '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg" style="height: 1.5rem;width: 1.5rem;animation: inex-spinner .5s linear infinite;fill: #449DA7;margin-left: 8px;"><style>@keyframes inex-spinner{to{transform:rotate(1turn)}}</style><path d="M15.542 1.487A21.507 21.507 0 00.5 22c0 11.874 9.626 21.5 21.5 21.5 9.847 0 18.364-6.675 20.809-16.072a1.5 1.5 0 00-2.904-.756C37.803 34.755 30.473 40.5 22 40.5 11.783 40.5 3.5 32.217 3.5 22c0-8.137 5.3-15.247 12.942-17.65a1.5 1.5 0 10-.9-2.863z"></path></svg>';
        var btnOldTitle = $(this).html();
        let isCheckout = $(this).attr('data-checkout');
        $(this).html("Please wait...");

        $(this).prop("disabled", true);
        let ringAtcData = {};
        let stoneAtcData = {};
        ringAtcData = await getRingDataForAtc();
        stoneAtcData = await getStoneDataForAtc();
        let items = [];

        items.push(ringAtcData);
        items.push(stoneAtcData);
        $addToCartTry = 0;

        await atcProcess(items, isCheckout);

        $(this).html(btnOldTitle);
        $(this).prop("disabled", false);
    }
});
async function getRingDataForAtc() {
    const ring_size = getCookie("vdbrb_ring_size");
    
    let ring_prod_variant_id = $("#vdbrb_setting_hdn_prod_var_id").val();
    let prop = {};
    $(".lineitem_prop").each(function () {
        prop[$(this).data("name")] = $(this).val();
    });
    prop["_Order Group ID"] = timestampForATC;
    prop["Ring Size"] = ring_size;

    let ringAtcData = {};
    ringAtcData = {
        quantity: 1,
        id: Number(ring_prod_variant_id),
        properties: prop,
    };
    return ringAtcData;
}
async function getStoneDataForAtc() {
    $(".vdbrb_add_to_cart_btn").prop("disabled", true);
    $(".vdbrb_add_to_cart_btn").addClass("disabled");
    let params = new URLSearchParams(window.location.search);
    let diamond_stock_num = params.has("diamond_stock_num") ? params.get("diamond_stock_num") : "";
    let stoneData = $(`#vdbrc_diamond_details_${diamond_stock_num}`).text();
    const stone = JSON.parse(stoneData);
    const formatValue = (value, defaultValue = "") => value ?? defaultValue;
    const formatSize = (size) => (size ? Number(size).toFixed(2) : "");
    let stoneAtcData = {};
    if (Object.keys(stone).length > 0) {
        const stock_num = stone["stock_num"];
        const stock_id = stone["id"];
        const shape = formatValue(stone["shape"]);
        const size = formatSize(stone["size"]);
        const color = formatValue(stone["color"]);
        const clarity = formatValue(stone["clarity"]);
        const image_url = formatValue(stone["image_url"]);
        const total_sales_price = stone["total_sales_price"];
        const long_title = formatValue(stone["long_title"]);
        const cert_num = formatValue(stone["cert_num"]);
        const comments = formatValue(stone["comments"]);
        const name = long_title || `${shape} ${size} ${color} ${clarity}`;
        const stone_currency_code = stone["currency_code"] ? stone["currency_code"] : "USD";
        const price = handlePriceData(stone_currency_code, total_sales_price, true);
        let processToken = getCookie("vdb_process_token");
        if (!processToken) {
            processToken = generateProcessToken();
            document.cookie = `vdb_process_token=${processToken}`;
        }
        const productAddItems = {
            action: "stone_product_info",
            shop: shop,
            product_title: name,
            product_price: price,
            stock_num: stock_num,
            stock_id: stock_id,
            prod_img: image_url,
            product_token: processToken,
        };
        try {
            const response = await fetch(API_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(productAddItems),
            });
            if (response.ok) {
                const responseData = await response.json();
                if (responseData?.isSuccess === "1") {
                    let prop = {};
                    prop = {
                        "Request Type": "Purchase Request",
                        "Stock ID": stock_id,
                        "_Stock #": stock_num,
                        "Certificate No": cert_num,
                        "_Order Group ID": timestampForATC
                    };
                    stoneAtcData = {
                        quantity: 1,
                        id: Number(responseData?.var_id),
                        properties: prop,
                    };
                    $(".vdbrb_add_to_cart_btn").prop("disabled", false);
                    $(".vdbrb_add_to_cart_btn").removeClass("disabled");
                }
            }
        } catch (error) {
            console.log(error);
        }
        return stoneAtcData;
    } else {
        alert("Selected Diamond Not Found");
        return stoneAtcData;
    }
}
const atcProcess = async (cartItems, isCheckout = false) => {
    $(".vdbrb_add_to_cart_btn").prop("disabled", true);
    $(".vdbrb_add_to_cart_btn").addClass("disabled");
    let cartItemsData = cartItems;
    const cartResult = await fetch("/cart.json");
    const cartData = await cartResult.json();
    if (cartData.item_count > 0) {
        const itemIds = cartData?.items.map((item) => item.id);
        cartItemsData = cartItemsData.filter((obj) => !itemIds.includes(obj.id));
    }
    if (cartItemsData.length > 0) {
        const payload = JSON.stringify({
            items: cartItemsData,
        });
        try {
            const response = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
                body: payload,
            });
            if (response.ok) {
                forgetAllSettings();
                if ($addToCartTry < 2) {
                    sleep(2000);
                    atcProcess(cartItems, isCheckout);
                } else {
                    // top.location.href = "/cart";
                    if (isCheckout == "true") {
                        $(".vdbrb_add_to_cart_btn").prop("disabled", false);
                        $(".vdbrb_add_to_cart_btn").removeClass("disabled");
                        top.location.href = "/checkout"
                    } else {
                        $('.vdb-close').trigger('click');
                        $(".vdbrb_add_to_cart_btn").prop("disabled", false);
                        $(".vdbrb_add_to_cart_btn").removeClass("disabled");
                        $(".vdbrb_ring_detail_link").trigger("click");
                        top.location.href = "/cart";
                    }
                }
            } else {
                $addToCartTry++;
                if ($addToCartTry < 5) {
                    sleep(2000);
                    atcProcess(cartItems, isCheckout);
                } else {
                    // top.location.href = "/cart";
                    if (isCheckout == "true") {
                        $(".vdbrb_add_to_cart_btn").prop("disabled", false);
                        $(".vdbrb_add_to_cart_btn").removeClass("disabled");
                        top.location.href = "/checkout"
                    } else {
                        $('.vdb-close').trigger('click');
                        $(".vdbrb_add_to_cart_btn").prop("disabled", false);
                        $(".vdbrb_add_to_cart_btn").removeClass("disabled");
                        $(".vdbrb_ring_detail_link").trigger("click");
                        top.location.href = "/cart";
                    }
                }
            }
        } catch (error) {
            $addToCartTry++;
            if ($addToCartTry < 5) {
                sleep(2000);
                atcProcess(cartItems, isCheckout);
            } else {
                // top.location.href = "/cart";
                if (isCheckout == "true") {
                    $(".vdbrb_add_to_cart_btn").prop("disabled", false);
                    $(".vdbrb_add_to_cart_btn").removeClass("disabled");
                    top.location.href = "/checkout"
                } else {
                    $('.vdb-close').trigger('click');
                    $(".vdbrb_add_to_cart_btn").prop("disabled", false);
                    $(".vdbrb_add_to_cart_btn").removeClass("disabled");
                    $(".vdbrb_ring_detail_link").trigger("click");
                    top.location.href = "/cart";
                }
            }
        }
    } else {
        // top.location.href = "/cart";
        if (isCheckout == "true") {
            $(".vdbrb_add_to_cart_btn").prop("disabled", false);
            $(".vdbrb_add_to_cart_btn").removeClass("disabled");
            top.location.href = "/checkout"
        } else {
            $('.vdb-close').trigger('click');
            $(".vdbrb_add_to_cart_btn").prop("disabled", false);
            $(".vdbrb_add_to_cart_btn").removeClass("disabled");
            $(".vdbrb_ring_detail_link").trigger("click");
            top.location.href = "/cart";
        }
    }
};
//#endregion

$("body").on("click", ".vdbrb_checkout_btn", async function () {
    $(this).prop("disabled", true);
    setTimeout(function () {
        top.location.href = "/checkout";
    }, 2000);
    $(this).prop("disabled", false);
});

$("body").on("change", ".vdbrc_ring_size", function () {
    const ring_size = $(this).val();
    document.cookie = `vdbrb_ring_size=${ring_size}`;
});

const validateEmail = (email) => {
    let validRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let specialChar = ["!", "#", "$", "%", "&", "'", "*", "+", "�", "/", "=", "?", "^", "_", "`", ".", "{", "}", "|", "~",];
    if (email.match(validRegex)) {
        if (email.includes("@-") || email.slice(-4) == ".web" || specialChar.includes(email.slice(0, 1))) {
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
};
async function call_stone_again() {
    $ajax_call_stone_list_running = "No";
    $("#vdbrb_labgrown_page_number").val("1");
    await call_labgrown_list();
}
async function call_labgrown_list(stock_num = "") {
    if ($ajax_call_stone_list_running === "No") {
        $ajax_call_stone_list_running = "Yes";
        if ($xhr) {
            // Cancel previous AJAX call and consider only the last one
            $xhr.abort();
        }
        const sendData = new URLSearchParams();
        let params = new URLSearchParams(window.location.search);
        if (stock_num != "") {
            sendData.append("stock_num", stock_num);
            resetDeepLink(false); // false for don't remove diamond_stock_num from param
        } /* else if (params.has("diamond_stock_num")) {
            sendData.append("stock_num", params.get("diamond_stock_num"));
            resetDeepLink(false); // false for don't remove diamond_stock_num from param
        } */ else {
            resetDeepLink();
        }
        let pushstate_string = window.top.location.href;
        const page_number = $("#vdbrb_labgrown_page_number").val();
        sendData.append("action", "get_labgrown_list");
        sendData.append("shop", shop);
        sendData.append("page_number", page_number);
        sendData.append("total_count", $stoneTotal);
        const sortingField = "";
        const sortingSeq = "";
        sendData.append("sorting_field", sortingField);
        sendData.append("sorting_seq", sortingSeq);
        let pageNumber = parseInt(page_number, 10) + 1;
        $("#vdbrb_labgrown_page_number").val(pageNumber);
        const addCookieData = (param, cookieName, urlParam) => {
            const cookieValue = getCookie(cookieName);
            if (cookieValue) {
                sendData.append(param, cookieValue);
                pushstate_string = updateUrl(pushstate_string, urlParam, cookieValue);
            }
        };
        addCookieData("sorting", "vdbrb_labgrown_sorting", "sorting");
        // Get shape
        const vdbrbLabgrownShapeStyle = getCookie("vdbrb_labgrown_shape_style");
        if (vdbrbLabgrownShapeStyle) {
            sendData.append("shape_data", vdbrbLabgrownShapeStyle);
            pushstate_string = updateUrl(pushstate_string, "shape", vdbrbLabgrownShapeStyle);
        } else {
            sendData.append("shape_data", labgrownShapeArray.join(","));
        }
        // Get Price values min and max
        const rate = market_currency !== shop_currency ? $market_currency_rate : $currency_rate;
        const addPriceData = (param, cookieName, rate, defaultValue) => {
            const cookieValue = getCookie(cookieName);
            if (cookieValue) {
                const price = parseFloat(cookieValue * rate).toFixed(2);
                sendData.append(param, price);
                pushstate_string = updateUrl(pushstate_string, param, price);
            } else {
                sendData.append(param, parseFloat(defaultValue * rate).toFixed(2));
            }
        };
        addPriceData("min_price", "vdbrb_labgrown_min_price", rate, default_min_price_labgrown);
        addPriceData("max_price", "vdbrb_labgrown_max_price", rate, default_max_price_labgrown);
        // Get Carat values min and max
        const addCaratData = (param, cookieName, defaultValue) => {
            const cookieValue = getCookie(cookieName);
            if (cookieValue) {
                const carat = parseFloat(cookieValue).toFixed(2);
                sendData.append(param, carat);
                pushstate_string = updateUrl(pushstate_string, param, carat);
            } else {
                sendData.append(param, parseFloat(defaultValue).toFixed(2));
            }
        };
        addCaratData("min_carat", "vdbrb_labgrown_min_carat", default_min_carat_labgrown);
        addCaratData("max_carat", "vdbrb_labgrown_max_carat", default_max_carat_labgrown);
        // Get Clarity values to and from
        const addClarityData = (param, cookieName, defaultValue) => {
            const cookieValue = getCookie(cookieName);
            if (cookieValue) {
                const clarity = cookieValue.split(",");
                const clarity_to = clarity[0];
                const clarity_from = clarity[clarity.length - 1];
                pushstate_string = updateUrl(pushstate_string, "clarity_to", clarity_to);
                pushstate_string = updateUrl(pushstate_string, "clarity_from", clarity_from);
                sendData.append(param, `${clarity_to},${clarity_from}`);
            } else {
                const clarity_to = defaultValue[0];
                const clarity_from = defaultValue[defaultValue.length - 1];
                sendData.append(param, `${clarity_to},${clarity_from}`);
            }
        };
        addClarityData("clarity_data_wrap", "vdbrb_labgrown_clarity", labgrownClarityArray);
        // Get Color values to and from
        const addColorData = (param, cookieName, defaultValue) => {
            const cookieValue = getCookie(cookieName);
            if (cookieValue) {
                const color = cookieValue.split(",");
                const color_to = color[0];
                const color_from = color[color.length - 1];
                pushstate_string = updateUrl(pushstate_string, "color_to", color_to);
                pushstate_string = updateUrl(pushstate_string, "color_from", color_from);
                sendData.append(param, `${color_to},${color_from}`);
            } else {
                const color_to = defaultValue[0];
                const color_from = defaultValue[defaultValue.length - 1];
                sendData.append(param, `${color_to},${color_from}`);
            }
        };
        addColorData("color_data_wrap", "vdbrb_labgrown_color_white", labgrownColorArray);
        top.window.history.pushState({}, "", pushstate_string);
        const formatMoneyValue = (amount, format) => formatMoney(Math.round(amount) * 100, format);
        // Retrieve cookie values
        const {
            shape = "", color = "", minPrice = "", maxPrice = "", minCarat = "", maxCarat = "", clarity = "",
        } = {
            shape: getCookie("vdbrb_labgrown_shape_style"),
            color: getCookie("vdbrb_labgrown_color_white"),
            minPrice: getCookie("vdbrb_labgrown_min_price"),
            maxPrice: getCookie("vdbrb_labgrown_max_price"),
            minCarat: getCookie("vdbrb_labgrown_min_carat"),
            maxCarat: getCookie("vdbrb_labgrown_max_carat"),
            clarity: getCookie("vdbrb_labgrown_clarity"),
        };
        // Generate filter tags
        const filterTagHtmlArr = [
            addFilterTag(shape, "shape"), addFilterTag(color.replace(",", " - "), "color"), minPrice && maxPrice ? addFilterTag(`${formatMoneyValue(minPrice, moneyFormat)} - ${formatMoneyValue(
                maxPrice,
                moneyFormat
            )}`, "price") : "", minCarat && maxCarat ? addFilterTag(`${minCarat} - ${maxCarat} ct`, "carat") : "", addFilterTag(clarity, "clarity"),
        ];
        let filterTagHtml = filterTagHtmlArr.filter(function (item) {
            return item !== "" && item !== undefined && item !== null;
        });
        // Update HTML
        $("#vdbrc_select_filter_tag").html(filterTagHtml.join(""));
        $(".selectedValue").text(shape);
        $("#vdbrb_filter_count_mobile").html(`(${filterTagHtml.length})`);
        $("#vdbrb_list_cover_loader").show();
        $("#vdbrb_stone_list_view_row").html("");
        $("#vdbrb_stone_grid_view_row").html("");

        if (Number(page_number) == 1) {
            if ($xhrCount != undefined && $xhrCount != '') {
                //this is cancel multiple ajax call and consider only last ajax call
                $xhrCount.abort();
            }
            let pageSendData = sendData + '&only_count_fetch=yes';
            $xhrCount = $.post(API_URL, pageSendData, function (countResultData) {
                var countResultArray = JSON.parse(countResultData);
                if (countResultArray['total_count'] != undefined && countResultArray['total_count'] != null) {
                    $stoneTotal = number_format(countResultArray['total_count']);
                    document.cookie = "vdbrb_labgrown_stone_count=" + $stoneTotal;
                }
                $pageCount = countResultArray['page_count'];

                if ($stoneTotal == 0 || $stoneTotal == '0') {
                    $("#vdbrb_stone_list_view_row").html('<div class="vdb-rb-no-diamond-found">No diamond found.</div>');
                    $("#vdbrb_pagination_block").html("");
                    $("#vdbrb_stone_grid_view_row").html('<div class="vdb-rb-no-diamond-found">No diamond found.</div>');
                }

                var paginationHtml = inex_pagination(countResultArray['current_page'], $pageCount, countResultArray['adjacents']);
                $("#vdbrb_pagination_block").html(paginationHtml);
            });
        }

        $xhr = await new Promise((resolve, reject) => {
            $.post(API_URL, sendData.toString(), (resultData) => {
                $ajax_call_stone_list_running = "No";
                $("#vdbrb_list_cover_loader").hide();
                const resultArray = JSON.parse(resultData);
                const mainData = resultArray?.main_data?.response?.body || {};
                const stoneArray = mainData.diamonds || [];
                if (mainData.total_count) {
                    $stoneTotal = number_format(mainData.total_count);
                    document.cookie = `vdbrb_labgrown_stone_count=${$stoneTotal}`;
                } else if (mainData.total_diamonds_found) {
                    $stoneTotal = number_format(mainData.total_diamonds_found);
                    document.cookie = `vdbrb_labgrown_stone_count=${$stoneTotal}`;
                }
                $pageCount = resultArray.page_count;
                if (resultArray !== undefined && stoneArray.length > 0) {
                    let list_html = "";
                    let grid_html = "";
                    const formatValue = (value, defaultValue = "") => value ?? defaultValue;
                    const formatSize = (size) => (size ? Number(size).toFixed(2) : "");
                    for (let stone of stoneArray) {
                        const stock_num = stone["stock_num"];
                        const stock_id = stone["id"];
                        const lab = formatValue(stone["lab"]);
                        const shape = formatValue(stone["shape"]);
                        const size = formatSize(stone["size"]);
                        const clarity = formatValue(stone["clarity"]);
                        const image_url = formatValue(stone["image_url"]);
                        const color = formatValue(stone["color"]);
                        const cut_short = formatValue(stone["cut_short"]);
                        const cut_for_tbl = cut_short ? `${cut_short}.` : "";
                        const polish_short = formatValue(stone["polish_short"]);
                        const polish_for_tbl = polish_short ? `${polish_short}.` : "";
                        const symmetry = formatValue(stone["symmetry"]);
                        const fluor = formatValue(stone["fluor_intensity"]);
                        const is_fancy = formatValue(stone["is_fancy"], false);
                        const fancy_color_intensity_short = formatValue(stone["fancy_color_intensity_short"]);
                        const fancy_color_overtone_short = formatValue(stone["fancy_color_overtone_short"]);
                        const fancy_color_short = formatValue(stone["fancy_color_short"]);
                        const total_sales_price = stone["total_sales_price"];
                        const origin = formatValue(stone["country_of_origin"]);
                        const long_title = formatValue(stone["long_title"]);
                        const depth_per = formatValue(stone["depth_percent"]);
                        const table_per = formatValue(stone["table_percent"]);
                        const video_url = formatValue(stone["video_url"]);
                        const video_type = formatValue(stone["video_type"]);
                        const stone_currency_code = stone["currency_code"] ? stone["currency_code"] : "USD";
                        const measurements_arr = [
                            formatValue(stone["meas_length"], "0.00"), formatValue(stone["meas_width"], "0.00"), formatValue(stone["meas_depth"], "0.00"),
                        ];
                        const measurements = measurements_arr.every((element) => element === "0.00") ? "-" : measurements_arr.join(" x ");
                        var price = handlePriceData(stone_currency_code, total_sales_price);
                        const name = long_title || `${shape} ${size} ${color} ${clarity}`;
                        const displayName = `${size} carat ${shape} <span>${color} ${clarity} Lab</span>`;
                        const colorTitle = is_fancy ? `${fancy_color_intensity_short} ${fancy_color_overtone_short} ${fancy_color_short}`.trim() : color;
                        let shape_icon_url = "";
                        const shapeElement = $(`.vdb-stape-bg-main-box[data-api-value="${shape}"]`);
                        shape_icon_url = shapeElement.attr("data-icon-url");

                        let videoHtml = "";
                        if (video_type == 'native') {
                            videoHtml = `<video class="vdb_stone_video" src="" controls controlsList="nodownload" data-src="${video_url}"></video>'`;
                        } else {
                            videoHtml = `<iframe allow="autoplay" src="" frameborder="0" data-src="${video_url}"></iframe>`;
                        }
                        list_html += `
                            <div class="vdb_gd_data_tr vdb_rb_list_row_tr" data-stock-num="${stock_num}" data-stock-id="${stock_id}" data-video-url="${video_url}" data-image-url="${image_url}">
                                <div class="vdb_gd_data_body vdb_rb_list_row">
                                    <div class="vdb-custom-checkbox-block">
                                        <label class="vdb-custom-checkbox">
                                            <input type="checkbox" name="select_stone_checkbox" class="vdbrc_select_stone_checkbox" data-stock-num="${stock_num}" data-stock-id="${stock_id}" />
                                            <span class="vdb-checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="vdb_gs-td vdbrc_mobile_hide"> 
                                        <span>
                                            <img src="${shape_icon_url}"/>
                                        </span>
                                    </div>
                                    <div class="vdb_gs-td">
                                        <img src="${shape_icon_url}" class="vdbrc_web_hide vdbrc_mobile_hide"/>
                                        <span>${shape}</span>
                                    </div>
                                    <div class="vdb_gs-td"><span>${size}</span></div>
                                    <div class="vdb_gs-td"><span>${color}</span></div>
                                    <div class="vdb_gs-td"><span>${clarity}</span></div>
                                    <div class="vdb_gs-td"><span style="font-weight: 600;">${price}</span></div>
                                    <div class="vdb_gs-td vdbrc_mobile_hide"><span>${lab}</span></div>
                                    <div class="vdb_gs-td vdbrc_mobile_hide">
                                        <span>
                                            <svg width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16 0.577355C16 0.429563 15.9392 0.28177 15.8178 0.169112C15.5749 -0.0563706 15.1808 -0.0563706 14.9379 0.169112L7.99996 6.60616L1.06214 0.169112C0.819116 -0.0563706 0.425158 -0.0563706 0.182134 0.169112C-0.0607115 0.394594 -0.0607115 0.760116 0.182134 0.985598L7.55995 7.83089C7.8028 8.05637 8.19693 8.05637 8.43978 7.83089L15.8176 0.985598C15.9392 0.87294 16 0.725147 16 0.577355Z" fill="#464646"/>
                                            </svg>
                                        </span>
                                    </div>
                                </div>
                                <div class="vdb_gs_diamond-more-details vdbrb_diamond_more_details" style="display: none;">
                                    <div class="vdb_gs-product-img">
                                        <img src="" class="vdbrb_stone_img" style="display: none;"> 
                                        ${videoHtml}
                                        <span class="vdb_download_certificate vdbrb_download_video" data-video-url="${video_url}">
                                            <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 16.5H13.4" stroke="#D7D7D7" stroke-linecap="round"></path>
                                                <path d="M6.84672 13.0464C6.65146 13.2417 6.65146 13.5583 6.84672 13.7536C7.04198 13.9488 7.35856 13.9488 7.55383 13.7536L6.84672 13.0464ZM12.5138 8.79355C12.7091 8.59829 12.7091 8.28171 12.5138 8.08645C12.3186 7.89118 12.002 7.89118 11.8067 8.08645L12.5138 8.79355ZM6.84672 13.7536C7.04198 13.9488 7.35856 13.9488 7.55383 13.7536C7.74909 13.5583 7.74909 13.2417 7.55383 13.0464L6.84672 13.7536ZM2.59383 8.08645C2.39856 7.89118 2.08198 7.89118 1.88672 8.08645C1.69146 8.28171 1.69146 8.59829 1.88672 8.79355L2.59383 8.08645ZM6.70027 13.4C6.70027 13.6761 6.92413 13.9 7.20027 13.9C7.47642 13.9 7.70027 13.6761 7.70027 13.4H6.70027ZM7.70027 1C7.70027 0.723858 7.47642 0.5 7.20027 0.5C6.92413 0.5 6.70027 0.723858 6.70027 1H7.70027ZM7.55383 13.7536L12.5138 8.79355L11.8067 8.08645L6.84672 13.0464L7.55383 13.7536ZM7.55383 13.0464L2.59383 8.08645L1.88672 8.79355L6.84672 13.7536L7.55383 13.0464ZM7.70027 13.4V1H6.70027V13.4H7.70027Z" fill="#D7D7D7"></path>
                                            </svg>
                                        </span>
                                    </div>
                                    <div class="vdb_gs-product-details">
                                        <div class="vdb_gs-product-detail-block">
                                            <div>
                                                <span>Shape </span><span>${shape}</span>
                                            </div>
                                            <div>
                                                <span>Origin </span><span>Lab-Grown Diamond</span>
                                            </div>
                                            <div>
                                                <span>Carat </span><span>${size} ct</span>
                                            </div>
                                            <div>
                                                <span>Color </span><span>${color}</span>
                                            </div>
                                            <div>
                                                <span>Clarity </span><span>${clarity}</span>
                                            </div>
                                            <div>
                                                <span>Symmetry </span><span>${symmetry}</span>
                                            </div>
                                            <div>
                                                <span>Measurements </span><span>${measurements} mm</span>
                                            </div>
                                            <div>
                                                <span>WEB ID</span><span>${stock_num}</span>
                                            </div>
                                            <a href="javascript:void(0);" class="vdb-btn vdbrb_select_diamond d-none" data-stock-num="${stock_num}" data-stock-id="${stock_id}">Select and Continue</a>
                                            <a href="javascript:void(0);" class="vdb-btn vdb-outline-btn vdbrc_diamond_details_popup_btn" data-stock-num="${stock_num}" data-stock-id="${stock_id}">Lab-Grown Diamond Details</a>
                                        </div>
                                    </div>
                                </div>
                                <textarea id="vdbrc_diamond_details_${stock_num}" data-stock-num="${stock_num}" data-stock-id="${stock_id}" style="display: none;">
                                    ${JSON.stringify(stone)}
                                </textarea>
                            </div>
                        `;
                        grid_html += `
                            <div class="vdb-select-diamond-view-grid-wp">
                                <p class="vdb-tag-text" style="display: none;">Tag Text</p>
                                <div class="effy-grid-view_thumbnail">
                                    <img src="" class="vdbrb_stone_grid_thumbnail" alt="${name}" data-src="${image_url}">
                                </div>
                                <h5>${displayName}</h5>
                                <p>${price}</p>
                                <div class="vdb_gs-select-btn">
                                    <a href="javascript:void(0);" class="vdb-btn vdbrb_select_diamond" data-stock-num="${stock_num}" data-stock-id="${stock_id}">Select this Lab-Grown Diamond</a>
                                    <a href="javascript:void(0);" class="vdb-btn vdb-outline-btn vdbrc_diamond_details_popup_btn" data-stock-num="${stock_num}" data-stock-id="${stock_id}">Lab-Grown Diamond Details</a>
                                </div>
                            </div>
                        `;
                    }
                    $("#vdbrb_stone_list_view_row").html(list_html);
                    $("#vdbrb_stone_grid_view_row").html(grid_html);
                    $("#vdbrb_stone_list_view_row .vdb_gs-product-img img, #vdbrb_stone_grid_view_block .vdb-select-diamond-view-grid-wp img").on("error", function () {
                        this.src = no_image_url;
                    });
                    if (params.has("diamond_stock_num") && (params.get("diamond_stock_num") != "")) {
                        let diamondStockNum = params.get("diamond_stock_num");
                        let stoneData = $(`#vdbrc_diamond_details_${diamondStockNum}`).text();
                        if (stoneData != '') {
                            const stone = JSON.parse(stoneData);
                            if (Object.keys(stone).length > 0) {
                                const total_sales_price = stone["total_sales_price"];
                                const stone_currency_code = stone["currency_code"] ? stone["currency_code"] : "USD";
                                const setting_price = $("#vdbrb_setting_hdn_prod_var_price").val();
                                let total_price = Number(setting_price) / 100 + Number(total_sales_price);
                                total_price = handlePriceData(market_currency, total_price);
                                $(".vdbrb_total_price").text(total_price);
                            }
                        }
                    }
                    let view_type = $("#vdbrb_view_dropdown").val();
                    if (view_type === "GRID_VIEW") {
                        $("#vdbrb_stone_grid_view_block img.vdbrb_stone_grid_thumbnail").each(function () {
                            const imgTag = $(this);
                            const dataSrc = imgTag.attr("data-src");

                            if (dataSrc) {
                                imgTag.attr("src", dataSrc).show(); // Load image if not set
                            }
                        });
                    }
                }

                if (Number(page_number) != 1) {
                    var paginationHtml = inex_pagination(resultArray['current_page'], resultArray['page_count'], resultArray['adjacents']);
                    $("#vdbrb_pagination_block").html(paginationHtml);
                }

                resolve();
            });
        });
    }
}

function updateUrl(url, key, value) {
    if (value !== undefined) {
        value = encodeURI(value);
    }
    var hashIndex = url.indexOf("#") | 0;
    if (hashIndex === -1) hashIndex = url.length | 0;
    var urls = url.substring(0, hashIndex).split("?");
    var baseUrl = urls[0];
    var parameters = "";
    var outPara = {};
    if (urls.length > 1) {
        parameters = urls[1];
    }
    if (parameters !== "") {
        parameters = parameters.split("&");
        for (k in parameters) {
            var keyVal = parameters[k];
            keyVal = keyVal.split("=");
            var ekey = keyVal[0];
            var evalue = "";
            if (keyVal.length > 1) {
                evalue = keyVal[1];
            }
            outPara[ekey] = evalue;
        }
    }
    if (value !== undefined) {
        outPara[key] = value;
    } else {
        delete outPara[key];
    }
    parameters = [];
    for (var k in outPara) {
        parameters.push(k + "=" + outPara[k]);
    }
    var finalUrl = baseUrl;
    if (parameters.length > 0) {
        finalUrl += "?" + parameters.join("&");
    }
    return finalUrl + url.substring(hashIndex);
}
async function deepLinkStone() {
    let params = new URLSearchParams(window.location.search);
    let reqShape = params.get("shape") || "";
    let reqToWhiteColor = params.get("color_to") || "";
    let reqFromWhiteColor = params.get("color_from") || "";
    let reqToClarity = params.get("clarity_to") || "";
    let reqFromClarity = params.get("clarity_from") || "";
    let reqMinCarat = params.get("min_carat") || "";
    let reqMaxCarat = params.get("max_carat") || "";
    let reqMinPrice = params.get("min_price") || "";
    let reqMaxPrice = params.get("max_price") || "";
    document.cookie = "vdbrb_labgrown_shape_style=";
    document.cookie = "vdbrb_labgrown_min_price=";
    document.cookie = "vdbrb_labgrown_max_price=";
    document.cookie = "vdbrb_labgrown_min_carat=";
    document.cookie = "vdbrb_labgrown_max_carat=";
    document.cookie = "vdbrb_labgrown_color_white=";
    document.cookie = "vdbrb_labgrown_clarity=";
    if (reqShape != "") {
        let reqShapeArray = reqShape.split(",");
        document.cookie = `vdbrb_labgrown_shape_style=${reqShapeArray.join(",")}`;
    }
    if (reqToWhiteColor != "" && reqFromWhiteColor != "" && labgrownColorArray.includes(reqToWhiteColor) && labgrownColorArray.includes(reqFromWhiteColor)) {
        document.cookie = `vdbrb_labgrown_color_white=${reqToWhiteColor + "," + reqFromWhiteColor
            }`;
    }
    if (reqToClarity != "" && reqFromClarity != "") {
        document.cookie = `vdbrb_labgrown_clarity=${reqToClarity + "," + reqFromClarity
            }`;
    }
    if (reqMinCarat != "" && reqMaxCarat != "" && Number(reqMinCarat) <= Number(reqMaxCarat)) {
        reqMinCarat = checkValueInRange(reqMinCarat, default_min_carat_labgrown, default_max_carat_labgrown);
        reqMaxCarat = checkValueInRange(reqMaxCarat, default_min_carat_labgrown, default_max_carat_labgrown);
        document.cookie = `vdbrb_labgrown_min_carat=${parseFloat(
            reqMinCarat
        ).toFixed(2)}`;
        document.cookie = `vdbrb_labgrown_max_carat=${parseFloat(
            reqMaxCarat
        ).toFixed(2)}`;
    } else if (reqMinCarat != "") {
        reqMinCarat = checkValueInRange(reqMinCarat, default_min_carat_labgrown, default_max_carat_labgrown);
        document.cookie = `vdbrb_labgrown_min_carat=${parseFloat(
            reqMinCarat
        ).toFixed(2)}`;
    } else if (reqMaxCarat != "") {
        reqMaxCarat = checkValueInRange(reqMaxCarat, default_min_carat_labgrown, default_max_carat_labgrown);
        document.cookie = `vdbrb_labgrown_max_carat=${parseFloat(
            reqMaxCarat
        ).toFixed(2)}`;
    }
    if (reqMinPrice != "" && reqMaxPrice != "" && Number(reqMinPrice) <= Number(reqMaxPrice)) {
        document.cookie = `vdbrb_labgrown_min_price=${reqMinPrice}`;
        document.cookie = `vdbrb_labgrown_max_price=${reqMaxPrice}`;
    } else if (reqMinPrice != "") {
        document.cookie = `vdbrb_labgrown_min_price=${reqMinPrice}`;
    } else if (reqMaxPrice != "") {
        document.cookie = `vdbrb_labgrown_max_price=${reqMaxPrice}`;
    }
}

function resetSpecificSlider(slider, stoneType = "labgrown") {
    let filteredObjects = sliderObjArray.filter((obj) => {
        if (obj.fromSlider && obj.fromSlider.id) {
            return (obj.fromSlider.id.includes(slider) && obj.fromSlider.id.includes(stoneType));
        }
        return false;
    });
    filteredObjects.forEach((obj) => {
        if (typeof obj.resetSlider === "function") {
            obj.resetSlider();
        }
    });
}

function addFilterTag(filterValue, filterType) {
    return filterValue ? `
        <div class="vdbrc_app_select_item_wrap" data-filter-type="${filterType}">
            <span>${filterValue}</span>
            <span>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 18C13.9235 18 18 13.9147 18 9C18 4.07647 13.9147 0 8.99118 0C4.07647 0 0 4.07647 0 9C0 13.9147 4.08529 18 9 18ZM5.88529 12.8471C5.48823 12.8471 5.16176 12.5118 5.16176 12.1059C5.16176 11.9118 5.24118 11.7353 5.37353 11.5941L7.95882 9.00882L5.37353 6.42353C5.24118 6.28235 5.16176 6.10588 5.16176 5.91176C5.16176 5.50588 5.48823 5.18824 5.88529 5.18824C6.09706 5.18824 6.26471 5.25882 6.39706 5.4L8.99118 7.98529L11.6118 5.39118C11.7618 5.24118 11.9206 5.17059 12.1147 5.17059C12.5118 5.17059 12.8382 5.49706 12.8382 5.89412C12.8382 6.09706 12.7765 6.25588 12.6265 6.41471L10.0324 9.00882L12.6176 11.5853C12.7588 11.7353 12.8294 11.9029 12.8294 12.1059C12.8294 12.5118 12.5029 12.8471 12.0971 12.8471C11.8941 12.8471 11.7176 12.7588 11.5765 12.6265L8.99118 10.0412L6.42353 12.6265C6.28235 12.7676 6.09706 12.8471 5.88529 12.8471Z" fill="#AEAEAE"/>
                </svg>
            </span>
        </div>
    ` : "";
}

function set_default_module_by_cookie_labgrown() {
    $("#vdbrb_labgrown_page_number").val("1");
    document.cookie = "vdbrb_labgrown_page_number=" + "1";
    const formatMoneyValue = (amount, format) => formatMoney(Math.round(amount) * 100, format);
    let selectedFilterTagHtml = "";
    //Shape
    const vdbrbLabgrownShapeStyle = getCookie("vdbrb_labgrown_shape_style");
    if (vdbrbLabgrownShapeStyle) {
        const shapeArr = vdbrbLabgrownShapeStyle.split(",");
        let shapeValueArray = [];
        $(".vdbrb_list_item_shape_labgrown").each(function () {
            const $this = $(this);
            if (shapeArr.includes($this.data("api-value"))) {
                $this.addClass("vdb-shape-select-stone");
                shapeValueArray.push($this.data("api-value"));
            }
        });
        shapeValueArray = array_unique(shapeValueArray);
        if (shapeValueArray.length > 0) {
            selectedFilterTagHtml += addFilterTag(shapeValueArray.join(","), "shape");
        }
    }
    // Min Price
    const minPrice = getCookie("vdbrb_labgrown_min_price");
    const minPriceInputWeb = $(".vdbrb_min_price_labgrown_web");
    if (minPrice) {
        if (minPriceInputWeb.length > 0) {
            minPriceInputWeb.val(minPrice);
            $("#vbdrb_price_from_slider_labgrown_web, #vbdrb_price_from_slider_labgrown_mobile").val(minPrice);
        }
    }
    // Max Price
    const maxPrice = getCookie("vdbrb_labgrown_max_price");
    const maxPriceInputWeb = $(".vdbrb_max_price_labgrown_web");
    if (maxPrice) {
        if (maxPriceInputWeb.length > 0) {
            maxPriceInputWeb.val(maxPrice);
            $("#vbdrb_price_to_slider_labgrown_web, #vbdrb_price_to_slider_labgrown_mobile").val(maxPrice);
        }
    }
    minPrice && maxPrice ? (selectedFilterTagHtml += addFilterTag(`${formatMoneyValue(minPrice, moneyFormat)} - ${formatMoneyValue(
        maxPrice,
        moneyFormat
    )}`, "price")) : "";
    // Min Carat
    const minCarat = getCookie("vdbrb_labgrown_min_carat");
    const minCaratInputWeb = $(".vdbrb_min_carat_labgrown_web");
    if (minCarat) {
        if (minCaratInputWeb.length > 0) {
            minCaratInputWeb.val(minCarat);
            $("#vbdrb_carat_from_slider_labgrown_web, #vbdrb_carat_from_slider_labgrown_mobile").val(minCarat);
        }
    }
    // Max Carat
    const maxCarat = getCookie("vdbrb_labgrown_max_carat");
    const maxCaratInputWeb = $(".vdbrb_max_carat_labgrown_web");
    if (maxCarat) {
        if (maxCaratInputWeb.length > 0) {
            maxCaratInputWeb.val(maxCarat);
            $("#vbdrb_carat_to_slider_labgrown_web, #vbdrb_carat_to_slider_labgrown_mobile").val(maxCarat);
        }
    }
    minCarat && maxCarat ? (selectedFilterTagHtml += addFilterTag(`${minCarat} - ${maxCarat} ct`, "carat")) : "";
    // Clarity
    const vdbrbLabgrownClarity = getCookie("vdbrb_labgrown_clarity");
    if (vdbrbLabgrownClarity) {
        const clarityArr = vdbrbLabgrownClarity.split(","); // ['FL','IF','VVS1']
        const firstClarity = clarityArr[0]; // FL
        const lastClarity = clarityArr[clarityArr.length - 1]; // VVS1
        if (Array.isArray(labgrownClarityArray) && labgrownClarityArray.length > 0) {
            const firstClarityKey = getKeyByValue(labgrownClarityArray, firstClarity); // 1
            const lastClarityKey = getKeyByValue(labgrownClarityArray, lastClarity); // 3
            $("#vbdrb_clarity_from_slider_labgrown_web, #vbdrb_clarity_from_slider_labgrown_mobile").val(firstClarityKey);
            $("#vbdrb_clarity_to_slider_labgrown_web, #vbdrb_clarity_to_slider_labgrown_mobile").val(lastClarityKey);
        }
        const vdbrbLabgrownClarityRange = clarityArr.join(" - ");
        selectedFilterTagHtml += addFilterTag(vdbrbLabgrownClarityRange, "clarity");
    }
    // Color
    const vdbrbLabgrownColorWhite = getCookie("vdbrb_labgrown_color_white");
    if (vdbrbLabgrownColorWhite) {
        const colorArray = vdbrbLabgrownColorWhite.split(",");
        let firstColorWhite = colorArray[0];
        let lastColorWhite = colorArray[colorArray.length - 1];
        if (Array.isArray(labgrownColorArray) && labgrownColorArray.length > 0) {
            firstColorWhite = getKeyByValue(labgrownColorArray, firstColorWhite);
            lastColorWhite = getKeyByValue(labgrownColorArray, lastColorWhite);
            $("#vbdrb_white_color_from_slider_labgrown_web, #vbdrb_white_color_from_slider_labgrown_mobile").val(firstColorWhite);
            $("#vbdrb_white_color_to_slider_labgrown_web, #vbdrb_white_color_to_slider_labgrown_mobile").val(lastColorWhite);
        }
        selectedFilterTagHtml += addFilterTag(vdbrbLabgrownColorWhite.replace(/,/g, " - "), "color");
    }
    // Sorting
    const vdbrbLabgrownSorting = getCookie("vdbrb_labgrown_sorting");
    if (vdbrbLabgrownSorting) {
        $("#vdbrb_sort_dropdown").val(vdbrbLabgrownSorting);
        $(".vdb_mobile_drop_fitler").find(`div[data-value="${vdbrbLabgrownSorting}"]`).addClass("active");
    }
    $("#vdbrc_select_filter_tag").html(selectedFilterTagHtml);
}

function resetDeepLink(isRemovedStockNum = true) {
    let newUrl = removeURLParameters(window.top.location.href, "shape", "min_price", "max_price", "min_carat", "max_carat", "color_to", "color_from", "clarity_to", "clarity_from", "sorting");
    if (isRemovedStockNum) {
        newUrl = removeURLParameters(newUrl, "diamond_stock_num");
    }
    top.window.history.pushState({}, "", newUrl);
}

function removeURLParameters(url, ...parameters) {
    const parsed = new URL(url);
    parameters.forEach((e) => parsed.searchParams.delete(e));
    return parsed.toString();
}
async function bindDiamondDetailPopup(stoneData) {
    let detail_html = "";
    const stone = JSON.parse(stoneData);
    const formatValue = (value, defaultValue = "") => value ?? defaultValue;
    const formatSize = (size) => (size ? Number(size).toFixed(2) : "");
    if (Object.keys(stone).length > 0) {
        const stock_num = stone["stock_num"];
        const stock_id = stone["id"];
        const lab = formatValue(stone["lab"]);
        const shape = formatValue(stone["shape"]);
        const size = formatSize(stone["size"]);
        const clarity = formatValue(stone["clarity"]);
        const image_url = formatValue(stone["image_url"]);
        const color = formatValue(stone["color"]);
        const cut_short = formatValue(stone["cut_short"]);
        const cut_for_tbl = cut_short ? `${cut_short}.` : "";
        const polish_short = formatValue(stone["polish_short"]);
        const polish_for_tbl = polish_short ? `${polish_short}.` : "";
        const symmetry = formatValue(stone["symmetry"]);
        const fluor = formatValue(stone["fluor_intensity"]);
        const is_fancy = formatValue(stone["is_fancy"], false);
        const fancy_color_intensity_short = formatValue(stone["fancy_color_intensity_short"]);
        const fancy_color_overtone_short = formatValue(stone["fancy_color_overtone_short"]);
        const fancy_color_short = formatValue(stone["fancy_color_short"]);
        const total_sales_price = stone["total_sales_price"];
        const origin = formatValue(stone["country_of_origin"]);
        const long_title = formatValue(stone["long_title"]);
        const depth_per = formatValue(stone["depth_percent"]);
        const table_per = formatValue(stone["table_percent"]);
        const video_url = formatValue(stone["video_url"]);
        const cert_url = formatValue(stone["cert_url"]);
        const stone_currency_code = stone["currency_code"] ? stone["currency_code"] : "USD";
        const measurements_arr = [
            formatValue(stone["meas_length"], "0.00"), formatValue(stone["meas_width"], "0.00"), formatValue(stone["meas_depth"], "0.00"),
        ];
        const measurements = measurements_arr.every((element) => element === "0.00") ? "-" : measurements_arr.join(" x ");
        var price = handlePriceData(stone_currency_code, total_sales_price);
        const name = long_title || `${shape} ${size} ${color} ${clarity}`;
        const colorTitle = is_fancy ? `${fancy_color_intensity_short} ${fancy_color_overtone_short} ${fancy_color_short}`.trim() : color;
        let certificate_html = "";
        var cert_url_arr = cert_url.split(".");
        var ext = cert_url_arr.pop();
        ext = ext.toLowerCase();
        if (cert_url != "") {
            if (ext == "pdf") {
                certificate_html = `<iframe src="" data-src="https://docs.google.com/gview?url=${cert_url}&embedded=true" style="width: 350px;height: 350px;margin-top: 15px;" frameborder="0"></iframe><br/>`;
            } else if (ext == "jpg" || ext == "jpeg" || ext == "png") {
                certificate_html = `<img src="${cert_url}" class="w-100" />`;
            } else if (new URL(cert_url).hostname.startsWith("www.")) {
                certificate_html = `
                  <br/>
                  <a href="${cert_url}" class="vdb-underline-btn" target="_blank" data-cert-url="${cert_url}">View Certificate</a>
                  <br/>
                `;
            } else {
                certificate_html = `<img src="${cert_url}" class="w-100" />`;
            }
        }
        detail_html = `
            <div class="vdb_diamond_details_download">
                <div class="vdb_diamond_details_iamge">
                    <img src="${image_url}" onerror="this.onerror=null;this.src='${no_image_url}';"> 
                    <span class="vdb_download_certificate vdbrb_download_video" data-video-url="${video_url}">
                        <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 16.5H13.4" stroke="#D7D7D7" stroke-linecap="round"/>
                            <path d="M6.84672 13.0464C6.65146 13.2417 6.65146 13.5583 6.84672 13.7536C7.04198 13.9488 7.35856 13.9488 7.55383 13.7536L6.84672 13.0464ZM12.5138 8.79355C12.7091 8.59829 12.7091 8.28171 12.5138 8.08645C12.3186 7.89118 12.002 7.89118 11.8067 8.08645L12.5138 8.79355ZM6.84672 13.7536C7.04198 13.9488 7.35856 13.9488 7.55383 13.7536C7.74909 13.5583 7.74909 13.2417 7.55383 13.0464L6.84672 13.7536ZM2.59383 8.08645C2.39856 7.89118 2.08198 7.89118 1.88672 8.08645C1.69146 8.28171 1.69146 8.59829 1.88672 8.79355L2.59383 8.08645ZM6.70027 13.4C6.70027 13.6761 6.92413 13.9 7.20027 13.9C7.47642 13.9 7.70027 13.6761 7.70027 13.4H6.70027ZM7.70027 1C7.70027 0.723858 7.47642 0.5 7.20027 0.5C6.92413 0.5 6.70027 0.723858 6.70027 1H7.70027ZM7.55383 13.7536L12.5138 8.79355L11.8067 8.08645L6.84672 13.0464L7.55383 13.7536ZM7.55383 13.0464L2.59383 8.08645L1.88672 8.79355L6.84672 13.7536L7.55383 13.0464ZM7.70027 13.4V1H6.70027V13.4H7.70027Z" fill="#D7D7D7"/>
                        </svg>
                    </span>
                </div>
                <div class="vdb_diamond_details_content text-left">
                    <h4>Lab-Grown Diamond Details</h4>
                    <p>${price}</p>
                    <div class="vdb_gs-product-details">
                        <div class="vdb_gs-product-detail-block">
                            <div>
                                <span>Origins</span>
                                <span>${lab}</span>
                            </div>
                            <div>
                                <span>Shape</span>
                                <span>${shape}</span>
                            </div>
                            <div>
                                <span>Carat</span>
                                <span>${size} ct</span>
                            </div>
                            <div>
                                <span>Color</span>
                                <span>${color}</span>
                            </div>
                            <div>
                                <span>Clarity</span>
                                <span>${clarity}</span>
                            </div>
                            <div>
                                <span>Symmetry </span>
                                <span>${symmetry}</span>
                            </div>
                            <div>
                                <span>Measurements </span>
                                <span>${measurements} mm</span>
                            </div>
                            <div>
                                <span>WEB ID</span>
                                <span>${stock_num}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vdb_certificate-frame text-left">
                ${certificate_html}
                ${cert_url
                ? `<a href="${cert_url}" class="vdb-underline-btn vdbrb_download_certificate" target="_blank" data-cert-url="${cert_url}" download>Download Certificate</a>`
                : ""
            }
            </div>
        `;
        $("#vdbrb_diamond_details_popup").html(detail_html);
    }
}

function checkValueInRange(inputValue, minValue, maxValue) {
    if (Number(inputValue) < Number(minValue)) {
        return Number(minValue);
    } else if (Number(inputValue) > Number(maxValue)) {
        return Number(maxValue);
    } else {
        return Number(inputValue);
    }
}

function copyToClipboard(data) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(data).then(function () {
            return true;
        }).catch(function (error) {
            console.error("Failed to copy the URL: ", error);
            return false;
        });
    } else {
        const tempTextarea = $("<textarea>");
        tempTextarea.val(data);
        $("body").append(tempTextarea);
        tempTextarea.select();
        try {
            document.execCommand("copy");
            tempTextarea.remove();
            return Promise.resolve(true);
        } catch (error) {
            console.error("Failed to copy the URL: ", error);
            tempTextarea.remove();
            return Promise.resolve(false);
        }
    }
}

function resetStoneFilter(isShapeRequireToReset = false) {
    document.cookie = "vdbrb_labgrown_page_number=1";
    document.cookie = "vdbrb_labgrown_color_white=";
    document.cookie = "vdbrb_labgrown_clarity=";
    document.cookie = "vdbrb_labgrown_min_price=";
    document.cookie = "vdbrb_labgrown_max_price=";
    document.cookie = "vdbrb_labgrown_min_carat=";
    document.cookie = "vdbrb_labgrown_max_carat=";
    document.cookie = "vdbrb_labgrown_sorting=";
    document.cookie = "vdbrb_labgrown_stone_count=";
    if (isShapeRequireToReset) {
        document.cookie = "vdbrb_labgrown_shape_style=";
        if ($(".vdbrb_list_item_shape_labgrown").length > 0) {
            $(".vdbrb_list_item_shape_labgrown").each(function () {
                $(this).removeClass("vdb-shape-select-stone");
            });
        }
    }
    sliderObjArray.forEach((obj) => {
        if (typeof obj.resetSlider === "function") {
            obj.resetSlider();
        }
    });
    $("#vdbrb_review_process").removeClass("active").removeClass("selected");
}

function handlePriceData(stoneCurrencyCode, total_sales_price, withoutFormate = false) {
    // Helper function to check if a value is defined and not empty
    function isValidCurrency(currency) {
        return currency !== undefined && currency !== null && currency !== "";
    }
    // Initial price conversion to shop currency
    let price = Math.round(price_in_shop_currency(total_sales_price));
    if (isValidCurrency(stoneCurrencyCode) && stoneCurrencyCode !== "USD") {
        if (stoneCurrencyCode !== shop_currency) {
            // Convert to USD first, then to shop currency
            let usd_price = parseFloat(currency_conversion(total_sales_price, stoneCurrencyCode, "USD"));
            price = Math.round(price_in_shop_currency(usd_price));
        } else {
            price = Math.round(total_sales_price);
        }
    }
    if (withoutFormate) {
        price = Math.round(total_sales_price);
    } else {
        price = formatMoney(price * 100, moneyFormat);
    }
    // Convert price to market currency if different from shop currency
    if (market_currency !== shop_currency) {
        price = Math.round(price_in_market_currency(total_sales_price));
        if (isValidCurrency(stoneCurrencyCode) && stoneCurrencyCode !== "USD") {
            if (stoneCurrencyCode !== market_currency) {
                // Convert to USD first, then to market currency
                let usd_price = parseFloat(currency_conversion(total_sales_price, stoneCurrencyCode, "USD"));
                price = Math.round(price_in_market_currency(usd_price));
            } else {
                price = Math.round(total_sales_price);
            }
        }
        if (withoutFormate) {
            price = Math.round(total_sales_price);
        } else {
            price = formatMoney(price * 100, market_currency_symbol + " {amount}");
        }
    }
    return price;
}

function handleCompatibleStoneShape(compatibleStoneShape) {
    if (compatibleStoneShape.length > 0) {
        $(".vdbrb_list_item_shape_labgrown").each(function () {
            const shape = $(this).data("api-value");
            if (compatibleStoneShape.includes(shape)) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    }
}

function bindRingDetailsModalHtml() {
    let html = "";
    let params = new URLSearchParams(window.location.search);
    let diamond_stock_num = params.has("diamond_stock_num") ? params.get("diamond_stock_num") : "";
    let stoneData = $(`#vdbrc_diamond_details_${diamond_stock_num}`).text();
    console.log("stoneData", stoneData);
    const stone = JSON.parse(stoneData);
    const formatValue = (value, defaultValue = "") => value ?? defaultValue;
    const formatSize = (size) => (size ? Number(size).toFixed(2) : "");
    let diamondDetailsHtml = "";
    let priceDetailsHtml = "";
    let settingDetailHtml = "";
    let diamondPrice = "";
    let settingPrice = "";
    let total_price = "";
    if (Object.keys(stone).length > 0) {
        const stock_num = stone["stock_num"];
        const lab = formatValue(stone["lab"]);
        const shape = formatValue(stone["shape"]);
        const size = formatSize(stone["size"]);
        const clarity = formatValue(stone["clarity"]);
        const color = formatValue(stone["color"]);
        const symmetry = formatValue(stone["symmetry"]);
        const measurements_arr = [
            formatValue(stone["meas_length"], "0.00"), formatValue(stone["meas_width"], "0.00"), formatValue(stone["meas_depth"], "0.00"),
        ];
        const measurements = measurements_arr.every((element) => element === "0.00") ? "-" : measurements_arr.join(" x ");
        const total_sales_price = stone["total_sales_price"];
        const stone_currency_code = stone["currency_code"] ? stone["currency_code"] : "USD";
        const setting_price = $("#vdbrb_setting_hdn_prod_var_price").val();

        total_price = Number(setting_price) / 100 + Number(total_sales_price);
        total_price = handlePriceData(stone_currency_code, total_price);
        diamondPrice = handlePriceData(stone_currency_code, total_sales_price);
        settingPrice = handlePriceData(market_currency, Number(setting_price) / 100);

        diamondDetailsHtml += `
            <li>
                <label>Shape:</label>
                <span>${shape}</span>
            </li>
            <li>
                <label>Carat Size:</label>
                <span>${size} ct</span>
            </li>
            <li>
                <label>Color:</label>
                <span>${color}</span>
            </li>
            <li>
                <label>Clarity:</label>
                <span>${clarity}</span>
            </li>
            <li>
                <label>Symmetry:</label>
                <span>${symmetry}</span>
            </li>
            <li>
                <label>WEB ID:</label>
                <span>${stock_num}</span>
            </li>
            <li>
                <label>Origin:</label>
                <span>Lab-Grown Diamond</span>
            </li>
        `;
    }
    let optionGroups = [];
    $("#vdbrb_setting_option_tab .vdb-setting-option").each(function () {
        optionGroups.push($(this).data("main-option-group"));
    });
    optionGroups.forEach(function (group) {
        let groupInputs = $(`.lineitem_prop[data-main-option-group='${group}']`);
        if (groupInputs.length > 0) {
            groupInputs.each(function () {
                let name = $(this).data("name");
                let value = $(this).val();
                settingDetailHtml += `
                    <li>
                        <label>${name}:</label>
                        <span>${value}</span>
                    </li>
                `;
            });
        }
    });
    html += `
        <div class="vdb-rc-ring-datails-in-popup vdb-ring-dt-right-side">
            <div class="vdb-rc-ring-datails-pop-componet">
                <h4>Ring</h4>
                <div class="vdb_gs-product-detail-block-wrapper">
                    <div class="vdb_gs-product-detail-block">
                        ${settingDetailHtml}
                    </div>
                    <a href="javascript:void(0);" id="vdb-rc-find-wedding-band-popup" data-main-option-group="Shape" class="vdb-underline-btn vdbrc_ring_detail_edit_btn">Edit</a>
                    <div class="vdb-component-price">${settingPrice}</div>
                </div>
            </div>
            <div class="vdb-rc-ring-datails-pop-componet">
                <h4>Lab-Grown Diamond</h4>
                <div class="vdb_gs-product-detail-block-wrapper">
                    <div class="vdb_gs-product-detail-block">
                        ${diamondDetailsHtml}
                    </div>
                    <a href="javascript:void(0);" id="vdb-rc-find-wedding-band-popup" class="vdb-underline-btn vdbrc_diamond_detail_edit_btn">Edit</a>
                    <div class="vdb-component-price">${diamondPrice}</div>
                </div>
            </div>
        </div>
        <div class="vdb-rc-ring-datails-pop-componet vdb-total-price">
            <h4>Total</h4>
            <div class="vdb-component-price">${total_price}</div>
        </div>
    `;
    $("#vdbrc_product_details_container").html(html);

    settingDetailHtml += `
        <li>
            <a href="javascript:void(0);" id="vdb-rc-find-wedding-band-popup" data-main-option-group="Shape" class="vdb-underline-btn vdbrc_ring_detail_edit_btn">
                Edit
            </a>
        </li>
    `;
    $("#vdbrb_review_ring_details").html(settingDetailHtml);

    diamondDetailsHtml += `
        <li>
            <a href="javascript:void(0);" id="vdb-rc-find-wedding-band-popup" class="vdb-underline-btn vdbrc_diamond_detail_edit_btn">
                Edit
            </a>
        </li>
    `;
    $("#vdbrb_review_ring_details").html(settingDetailHtml);
    $("#vdbrb_review_stone_details").html(diamondDetailsHtml);

}
async function handleStepContainer(step) {
    let params = new URLSearchParams(window.location.search);
    $('.vdbrb_step').removeClass('active');

    if (step == "design_ring") {
        $("#vdbrb_design_ring_module").removeClass("d-none");
        $("#vdbrb_design_ring_process").addClass('active');

        let pushstate_string = updateUrl(window.top.location.href, "step", "design_ring");
        window.top.history.pushState({}, "", pushstate_string);
        window.player.changeAutoRotate(false);

        $("#vdbrb_review_module").addClass("d-none");
        $("#vdbrb_review_page_details_right_container").addClass("d-none");
        $("#vdbrb_design_ring_tab_filter_right_container").removeClass("d-none");

        $(".vdbrb_ring_detail_link").addClass("d-none");
        $("#vdbrb_select_diamond_module").addClass("d-none");
        if (params.has("diamond_stock_num")) {
            $(".vdbrb_exclude_price_text").addClass("d-none");
            $(".vdbrb_header_price").removeClass("d-none");
        }

        $('#vdbrb_setting_option_tab .vdb-step[data-step="review"]').addClass("d-none").removeClass("vdb-step-active");
        $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_review_btn').addClass("d-none");
        $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_atc_btn').addClass("d-none");
        $('#vdbrb_setting_option_tab .vdb-next-btn').removeClass("text_btn");
    } else if (step == "select_diamond") {
        let pushstate_string = updateUrl(window.top.location.href, "step", "select_diamond");
        window.top.history.pushState({}, "", pushstate_string);

        $("#vdbrb_select_diamond_module").removeClass("d-none");
        $("#vdbrb_select_diamond_process").addClass('active');

        $("#vdbrb_design_ring_module").addClass("d-none");

        $("#vdbrb_review_module").addClass("d-none");
        $("#vdbrb_review_page_details_right_container").addClass("d-none");
        $("#vdbrb_design_ring_tab_filter_right_container").removeClass("d-none");

        $(".vdbrb_exclude_price_text").addClass("d-none");
        $(".vdbrb_header_price").removeClass("d-none");
        $(".vdbrb_ring_detail_link").addClass("d-none");

        deepLinkStone();
        set_default_module_by_cookie_labgrown();

        if (isMobileDevice()) {
            const elem = $('#vdbrb_stone_list_view_block');
            if (elem.length) {
                $('html, body').animate({
                    scrollTop: elem.offset().top - 130
                }, 100);
            }
        }

        scrollTillSelectedDiamond();
        // await call_stone_again();
    } else if (step == "review") {
        $("html, body").scrollTop(0);

        let pushstate_string = updateUrl(window.top.location.href, "step", "review");
        window.top.history.pushState({}, "", pushstate_string);

        $("#vdbrb_select_diamond_module").addClass("d-none");
        $("#vdbrb_design_ring_module").addClass("d-none");

        $(".vdbrb_ring_detail_link").removeClass("d-none");
        $("#vdbrb_review_process").addClass('active');

        $(".vdbrb_exclude_price_text").addClass("d-none");
        // $(".vdbrb_header_price").addClass("d-none");

        handleReviewPageBlock('show');

        deepLinkStone();
        set_default_module_by_cookie_labgrown();
        // await call_stone_again();
    } else if (step == "design_ring_start_over") {
        $("#vdbrb_design_ring_module").removeClass("d-none");
        $("#vdbrb_design_ring_process").addClass("active");
        /*  let pushstate_string = updateUrl(window.top.location.href, "step", "design_ring");
         window.top.history.pushState({}, "", pushstate_string); */

        $("#vdbrb_review_module").addClass("d-none");
        $("#vdbrb_review_page_details_right_container").addClass("d-none");
        $("#vdbrb_design_ring_tab_filter_right_container").removeClass("d-none");

        $(".vdbrb_ring_detail_link").addClass("d-none");
        $("#vdbrb_select_diamond_module").addClass("d-none");
        if (params.has("diamond_stock_num")) {
            $(".vdbrb_exclude_price_text").addClass("d-none");
        }

        $(".vdbrb_header_price").removeClass("d-none");

        resetStoneFilter(true);
        resetDeepLink();

        let pushstate_string = updateUrl(window.top.location.href, "step", "design_ring");
        window.location.href = pushstate_string;
    }
}

//#region : Setting Configurator Functions
$("body").on("click", "#vdbrb_setting_option_tab .vdb-step", function (event) {
    var attr_group_name = $(this).data("main-option-group") || '';

    // Early return if this step is already active
    /* if(attr_group_name != 'Shape' && $(this).hasClass("vdb-step-active")){
        return;
    } */
    
    const tabStep = $(this).data("step");

    if (attr_group_name != '') {
        console.log('attr_group_name', attr_group_name);
        $(`#vdbrb_setting_option_tab_data [data-attr_group_name]:not([data-attr_group_name="${attr_group_name}"])`).hide();
        $(`#vdbrb_setting_option_tab_data [data-attr_group_name="${attr_group_name}"]`).show();
        handleStepContainer('design_ring');
    }
    if (tabStep == 'review') {
        let checkedBox = $('.vdbrc_select_stone_checkbox:checked');
        if (checkedBox.length > 0) {
            let stockNum = checkedBox.data('stock-num');
            $(`.vdbrb_select_diamond[data-stock-num="${stockNum}"]`).trigger('click');
        } else {
            $("#vdbrb_select_diamond_popup").css("opacity", "1");
        }
    }

    $("#vdbrb_setting_option_tab .vdb-step").removeClass("vdb-step-active");
    $(this).addClass("vdb-step-active");

    updateArrows(!event.isTrigger);

    if (attr_group_name != "Shape") {
        $("#vdbrc_shape_warning_block").hide();
    }
});

$("body").on("click", "#vdbrb_setting_option_tab .vdb-next-btn, #vdbrb_setting_option_tab .vdb-prev-btn", async function () {
    const isNext = $(this).hasClass("vdb-next-btn");
    const activeTab = $("#vdbrb_setting_option_tab .vdb-step.vdb-step-active");
    const activeTabStep = $("#vdbrb_setting_option_tab .vdb-step.vdb-step-active").attr("data-step");
    const sibling = isNext ? activeTab.next(".vdb-step.vdb-setting-option") : activeTab.prev(".vdb-step.vdb-setting-option");

    if (sibling.length) {
        sibling.trigger("click");
    } else {
        const directionMethod = isNext ? 'nextAll' : 'prevAll';

        const diamondStep = activeTab[directionMethod]('.vdb-step[data-step="diamond_selection"]').first();
        if (diamondStep.length) {
            $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_atc_btn').addClass("d-none");
            $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_review_btn').addClass("d-none");
            $('#vdbrb_setting_option_tab .vdb-next-btn').removeClass("text_btn");

            $('.continue_diamond_section').trigger('click');
            $("#vdbrb_setting_option_tab .vdb-step").removeClass("vdb-step-active");
            diamondStep.addClass("vdb-step-active");
            return;
        }

        if (activeTabStep == 'diamond_selection') {
            let checkedBox = $('.vdbrc_select_stone_checkbox:checked');
            if (checkedBox.length > 0) {
                let stockNum = checkedBox.data('stock-num');
                $(`.vdbrb_select_diamond[data-stock-num="${stockNum}"]`).trigger('click');
                $(this).removeClass("disable");
            } else {
                $("#vdbrb_select_diamond_popup").css({
                    "opacity": "1",
                    "pointer-events": "all",
                    "visibility": "visible"
                });
                return;
            }
        }

        const reviewStep = activeTab[directionMethod]('.vdb-step[data-step="review"]').first();
        if (reviewStep.length) {
            $("#vdbrb_setting_option_tab .vdb-step").removeClass("vdb-step-active");
            reviewStep.addClass("vdb-step-active");
            handleReviewPageBlock('show');
        }

        if(activeTabStep == "review"){
            $(".vdbrb_add_to_cart_btn").trigger("click");
        }
    }

    updateArrows();
});

function updateArrows(isUpdate3DView = true) {
    const activeTab = $("#vdbrb_setting_option_tab .vdb-step.vdb-step-active");
    const activeTabStep = $("#vdbrb_setting_option_tab .vdb-step.vdb-step-active").attr("data-step");
    const nextTab = activeTab.next(".vdb-step");
    const prevTab = activeTab.prev(".vdb-step");
    console.log('HERE');
    if (nextTab.length === 0 && activeTabStep != 'review') {
        $("#vdbrb_setting_option_tab .vdb-next-btn").addClass("disable");
    } else {
        $("#vdbrb_setting_option_tab .vdb-next-btn").removeClass("disable");
    }
    if (prevTab.length === 0) {
        $("#vdbrb_setting_option_tab .vdb-prev-btn").addClass("disable");
    } else {
        $("#vdbrb_setting_option_tab .vdb-prev-btn").removeClass("disable");
    }

    if (isUpdate3DView) {
        update3DView();
    }

    $('body').removeClass('setting_option diamond_selection review').addClass(activeTabStep);
}
function update3DView() {
    const activeTabSlug = $("#vdbrb_setting_option_tab .vdb-setting-option.vdb-step-active").attr("data-main-option-group-slug");

    if (activeTabSlug == 'shape') {
        window.player.changeCameraAngle(-0.013760353248503415, 2.399252475980625, 0.02683782147519799);
    } else if (activeTabSlug == 'metal') {
        window.player.changeCameraAngle(2.0400166044254453, 1.5979015893519937, -1.967592657441214);
    } else if (activeTabSlug == 'setting') {
        window.player.changeCameraAngle(-0.1064981251887776, 1.4327101803298272, -2.9115563054564055);
    } else if (activeTabSlug == 'band') {
        window.player.changeCameraAngle(-2.4203522504605006, 1.8566111503078724, -1.2358300334076202);
    }
}
$("body").on("click", ".vdbrc_setting_attr_opt", async function (event) {
    const current_name = $(this).data("name");
    const current_value = $(this).data("value");
    const current_value_slug = $(this).data("slug");
    const current_main_option_slug = $(this).data("main-option-slug");
    const current_main_option_order = $(this).data("main-option-order");
    const currentScrollPosition = $(".vdb-shape-main-box").scrollLeft();

    let params = new URLSearchParams(window.location.search);
    let diamond_stock_num = params.has("diamond_stock_num") ? params.get("diamond_stock_num") : "";
    let isShapeSelectionAllow = $("#vdbrc_shape_warning_block").attr('data-is-allowed');

    if (current_main_option_slug === 'stone_shape' && diamond_stock_num !== '' && isShapeSelectionAllow == 'false' && !event.isTrigger) {
        $("#vdbrc_shape_warning_block").show();
        return false;
    } else {
        $("#vdbrc_shape_warning_block").attr('data-is-allowed', "false"); // Ensure it's a string
    }

    $(`.vdbrc_setting_attr_opt[data-main-option-slug="${current_main_option_slug}"]`).removeClass("active");
    $(this).addClass("active");
    $(`.lineitem_prop[data-main-option-slug="${current_main_option_slug}"]`).val(current_value);
    $(`.lineitem_prop[data-main-option-slug="${current_main_option_slug}"]`).attr("data-sub-option-slug", current_value_slug);

    let lineitemAttrObj = {};
    let parentSlugArray = [];
    const lineitemPropElements = $('.lineitem_prop[name*="attributes"]');
    lineitemPropElements.each(function () {
        const mainOptionSlug = $(this).attr("data-main-option-slug");
        const subOptionSlug = $(this).attr("data-sub-option-slug");
        const subOptionValue = $(this).attr("value");
        const mainOptionOrder = $(this).attr("data-main-option-order");
        lineitemAttrObj[mainOptionSlug] = subOptionValue;
        if (Number(mainOptionOrder) < Number(current_main_option_order)) {
            parentSlugArray.push(mainOptionSlug);
        }
    });
    if (lineitemAttrObj.metal_metal_color === "Platinum") {
        // lineitemAttrObj.metal_metal_type = "";
        delete lineitemAttrObj.metal_metal_type;
    }
    var commaSeparatedValues = [];
    $(`.variant_option[data-attr_slug="${current_main_option_slug}"]`).each(function () {
        var threekitAttrOpts = $(this).find(".vdbrc_setting_attr_opt");
        threekitAttrOpts.each(function () {
            commaSeparatedValues.push($(this).data("value"));
        });
    });
    var commaSeparatedValueString = commaSeparatedValues.join(",");
    let selectedItemObj = {};
    if (!selectedItemObj[current_main_option_slug]) {
        selectedItemObj[current_main_option_slug] = {};
    }
    selectedItemObj[current_main_option_slug]["selected_val"] = current_value;
    selectedItemObj[current_main_option_slug]["all_val"] = commaSeparatedValueString;
    selectedItemObj[current_main_option_slug]["parent_slugs"] = parentSlugArray;

    // Show loader while processing
    // $("#product_details_cover").show();
    $(".vdbrb_add_to_cart_btn").attr("disabled", true);

    const webgiProdInfo = await fetchProductRelatedAllDataBasedOnAttr(lineitemAttrObj, selectedItemObj);
    if (webgiProdInfo?.SUCCESS == "TRUE") {
        await generalProcessAfterFetchData(webgiProdInfo);
        handleThreeDPart(webgiProdInfo?.DATA, isUpdate = true);

        $(".product_detail_main .product_title h1").html(webgiProdInfo?.DATA?.product_title);
        $("#vdbrb_setting_hdn_prod_title").val(webgiProdInfo?.DATA?.product_title);
        $(".product_detail_main #pdp_addtocart_btn").val(webgiProdInfo?.DATA?.product_variant_id);
        $("#vdbrb_setting_hdn_prod_id").val(webgiProdInfo?.DATA?.product_id);
        $("#vdbrb_setting_hdn_prod_var_id").val(webgiProdInfo?.DATA?.product_variant_id);
        $("#vdbrb_setting_hdn_prod_var_sku").val(webgiProdInfo?.DATA?.product_variant_sku);
        $("#vdbrb_setting_hdn_prod_handle").val(webgiProdInfo?.DATA?.product_handle);
        $("#vdbrb_setting_hdn_configurator_name").val(webgiProdInfo?.DATA?.configurator);
        $("#vdbrb_setting_hdn_prod_var_price").val(Number(webgiProdInfo?.DATA?.product_variant_price) * 100);

        if (webgiProdInfo?.DATA?.product_featured_image) {
            $(".setting_product_img").attr('src', webgiProdInfo?.DATA?.product_featured_image + "&crop=center&height=400&width=500");
            $("#vdbrb_setting_hdn_prod_img").val(webgiProdInfo?.DATA?.product_featured_image + "&crop=center&height=400&width=500");
        }

        let prodImageArr = webgiProdInfo?.DATA?.product_images || [];
        let handViewUrl = "";
        if (prodImageArr.length > 0) {
            handViewUrl = prodImageArr.find((image) => image?.node?.altText === "hand-view")?.node.url;
        }
        if (handViewUrl && handViewUrl != "") {
            $("#hand_view_iframe").attr("src", "https://phpstack-1090158-5661194.cloudwaysapps.com/hand-view.php?img=" + handViewUrl);
            $("#vdb-hand-view-btn").show();
        } else {
            $("#vdb-hand-view-btn").hide();
        }

        let ringPrice = handlePriceData(market_currency, Number(webgiProdInfo?.DATA?.product_variant_price));
        $(".vdbrb_total_price").text(`${ringPrice}+`);

        if (current_main_option_slug === 'stone_shape') {
            window.history.pushState({}, "", "/products/" + webgiProdInfo?.DATA?.product_handle + "?variant=" + webgiProdInfo?.DATA?.product_variant_id);
        } else {
            // Preserve existing query parameters
            params.set("variant", webgiProdInfo?.DATA?.product_variant_id);

            // Construct new URL with updated product handle and existing params
            let newUrl = "/products/" + webgiProdInfo?.DATA?.product_handle + "?" + params.toString();
            window.history.pushState({}, "", newUrl);
        }

        handleCompatibleStoneShape(webgiProdInfo?.DATA?.compatible_stone_shape);
    } else {
        console.log("Data not found based on attribute");
    }
    $(".vdb-shape-main-box").scrollLeft(currentScrollPosition);

    // Hide loader and enable the button after processing is complete
    setTimeout(function () {
        // $("#product_details_cover").hide();
        $(".vdbrb_add_to_cart_btn").removeAttr("disabled");
    }, 1500);

    // If attr change than we have to remove selection from other module. this case for navigation (review to design)
    if (current_main_option_slug != 'stone_shape' && diamond_stock_num !== '') {
        let stoneData = $(`#vdbrc_diamond_details_${diamond_stock_num}`).text();
        const stone = JSON.parse(stoneData);
        if (Object.keys(stone).length > 0) {
            const total_sales_price = stone["total_sales_price"];
            const stone_currency_code = stone["currency_code"] ? stone["currency_code"] : "USD";
            const setting_price = $("#vdbrb_setting_hdn_prod_var_price").val();
            let total_price = Number(setting_price) / 100 + Number(total_sales_price);
            total_price = handlePriceData(stone_currency_code, total_price);
            $(".vdbrb_total_price").text(total_price);
            $(".vdbrb_exclude_price_text").addClass("d-none");
            $(".vdbrb_ring_detail_link").removeClass("d-none");
        }
    } else {
        $("#vdbrb_select_diamond_process").removeClass("active").removeClass("selected");
        $("#vdbrb_review_process").removeClass("active").removeClass("selected");
        $(".vdbrb_exclude_price_text").removeClass("d-none");
        $(".vdbrb_ring_detail_link").removeClass("d-none");
    }
});
$("body").on("click", ".setting_carat_block", function () {
    $(`.setting_carat_block`).removeClass("selected");
    $(this).addClass("selected");
});
const generalProcessAfterFetchData = async (webgiProdInfo) => {
    const { DATA } = webgiProdInfo;

    await bindOptionHtml(DATA?.option_data);

    let activeGroupSlug = $(".vdb-step-active").data("main-option-group-slug") || "";
    console.log("activeGroupSlug", activeGroupSlug);
    if (activeGroupSlug != "") {
        $("#vdbrb_setting_option_tab").find(`[data-main-option-group-slug="${activeGroupSlug}"]`).trigger("click");
    } /* else {
        $("#vdbrb_setting_option_tab").find("[data-main-option-group-slug]").first().trigger("click");
    } */
    $("#vdbrb_setting_hdn_configurator_name").val(DATA?.configurator);
};
const bindOptionHtml = async (optionsData) => {
    const mainOptions = optionsData ? Object.keys(optionsData) : [];
    let html = "";
    let tabHeaderHtml = "";
    let activeGroupSlug = $(".vdb-step-active").data("main-option-group-slug") || "";
    let activeStep = $(".vdb-step-active").data("step") || "";

    let params = new URLSearchParams(window.location.search);
    let step = params.get("step") || "";
    if(step == 'select_diamond'){
        activeStep = 'diamond_selection';
    }if(step == 'review'){
        activeStep = 'review';
    }

    let tabPrevBtnHtml = `
        <button class="vdb-prev-btn vdb-navigation-arrow" aria-label="Preview Step" data-step="vdb_tab_prev">
            <svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 1.62494L0.812501 7.81244L7 13.9999" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="d-none vdb_back-to-edit">Back to Edit</span>
        </button>`
        ;

    let tabNextBtnHtml = `
        <button class="vdb-next-btn vdb-navigation-arrow" aria-label="Next Step" data-step="vdb_tab_next">
            <span class="d-none vdb_review_btn">Review</span>
            <span class="d-none vdb_atc_btn">Add to Cart</span>
            <svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.8125 14L7 7.8125L0.812501 1.625" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>`
        ;

    //#region : Option Tab Header Html
    tabHeaderHtml += tabPrevBtnHtml;

    let uniqueGroups = new Set();
    Object.values(optionsData).forEach((array) => {
        array.forEach((item) => {
            uniqueGroups.add(item.group_name);
        });
    });
    let count = 1;

    let isActive = false;
    uniqueGroups.forEach((groupName, index) => {
        let groupSlug = convertToSlug(groupName);

        if (activeGroupSlug !== "") {
            isActive = activeGroupSlug === groupSlug;
        } else {
            isActive = (count === 1 && activeStep === "");
        }
        /* if (activeGroupSlug != "") {
            // tabHeaderHtml += `<li data-id="vdb-setting-option-tab-${index + 1}" class="${activeGroupSlug == groupSlug ? "vdb-step-active" : ""}" data-main-option-group="${groupName}" data-main-option-group-slug="${groupSlug}">${groupName}</li>`;

            tabHeaderHtml += `
                <div data-id="vdb-setting-option-tab-${count}" class="vdb-step vdb-setting-option ${activeGroupSlug == groupSlug ? "vdb-step-active" : ""}" data-step="setting_option" data-main-option-group="${groupName}" data-main-option-group-slug="${groupSlug}">
                    <span class="vdb-step-label">${count} ${groupName}</span>
                </div>`
                ;
        } else {
            // tabHeaderHtml += `<li data-id="vdb-setting-option-tab-${index + 1}" class="${index === 0 ? "vdb-step-active" : ""}" data-main-option-group="${groupName}" data-main-option-group-slug="${groupSlug}">${groupName}</li>`;

            tabHeaderHtml += `
                <div data-id="vdb-setting-option-tab-${count}" class="vdb-step vdb-setting-option ${(count === 1 && activeStep == '') ? "vdb-step-active" : ""}" data-main-option-group="${groupName}" data-step="setting_option" data-main-option-group-slug="${groupSlug}">
                    <span class="vdb-step-label">${count} ${groupName}</span>
                </div>`
                ;
        } */

        tabHeaderHtml += `
            <div data-id="vdb-setting-option-tab-${count}" 
                class="vdb-step vdb-setting-option ${isActive ? "vdb-step-active" : ""}" 
                data-step="setting_option" 
                data-main-option-group="${groupName}" 
                data-main-option-group-slug="${groupSlug}">
                <span class="vdb-step-label">${count}. ${groupName == 'Shape' ? 'Diamond Shape' : groupName}</span>
            </div>`
        ;
        count++;
    });
    //#endregion

    mainOptions.forEach((mainOption, index) => {
        const subArray = optionsData[mainOption];
        const {
            main_option_title,
            main_option_slug,
            main_option_order,
            group_name,
        } = subArray[0];
        const defaultSubOptionData = subArray.find(
            (subObject) => subObject?.is_default_value === "1");
        const defaultSubOption = defaultSubOptionData?.sub_option_title;
        const defaultSubOptionSlug = defaultSubOptionData?.sub_option_slug;
        // lineitem property field
        html += `<input type="hidden" class="lineitem_prop" data-main-option-order="${main_option_order}" data-main-option-group="${group_name}" data-name="${main_option_title}" name="attributes[${group_name}:${main_option_title}]" data-main-option-slug="${main_option_slug}" data-sub-option-slug="${defaultSubOptionSlug}" value="${defaultSubOption}">`;
        const variantOptionHtml = subArray.map((subObject) => {
            const {
                sub_option_title,
                sub_option_slug,
                sub_option_icon,
                is_default_value,
                group_name,
                display_option,
            } = subObject;
            const img = `${sub_option_icon}?format=webp`;
            const activeClass = is_default_value === "1" ? "active" : "";
            if (display_option == "square_icon_label") {
                return `
                    <div class="vdbrc_setting_attr_opt vdb-stape-bg-main-box ${activeClass} ${display_option}" title="${sub_option_title}" data-group-name="${group_name}" data-name="${main_option_title}" data-main-option-slug="${main_option_slug}" data-value="${sub_option_title}" data-slug="${sub_option_slug}">
                        <div class="vdb-stape-bg">
                            <img src="${img}">
                        </div>
                        <p>${sub_option_title}</p>
                    </div>
                `;
            } else if (display_option == "rectangle_label") {
                return `
                    <div class="vdbrc_setting_attr_opt vdb-stape-bg-main-box ${activeClass} ${display_option}" title="${sub_option_title}" data-group-name="${group_name}" data-name="${main_option_title}" data-main-option-slug="${main_option_slug}" data-value="${sub_option_title}" data-slug="${sub_option_slug}">
                        <div class="vdb-stape-bg">
                            <p>${sub_option_title}</p>
                        </div>
                    </div>
                `;
            }
        }).join("");
        html += `
            <div class="variant_option" data-attr_name="${main_option_title}" data-attr_group_name="${group_name}" data-attr_slug="${main_option_slug}">
                <div class="vdb-shap-componet">
                    <h6 class="vdb-shap-componet-heading" ${main_option_slug === 'stone_shape' ? 'style="display: none;"' : ''}>
                        ${main_option_title}
                    </h6>
                    <div class="vdb-shape-main-box">
                        ${variantOptionHtml}
                    </div>
                </div>
                ${group_name === "Shape" ? `<p class="vdb-rb-previewed-txt">*Estimation for preview. You will select your lab grown diamond later</p>` : ""}
            </div>
        `;
        if (group_name == "Shape") {
            if (settingCaretMinValue == "") {
                settingCaretMinValue = 0;
            }
            if (settingCaretMaxValue == "") {
                settingCaretMaxValue = 5;
            }
            if (settingCaretSteperValue == "") {
                settingCaretSteperValue = 1;
            }
            if (settingCaretDefaultValue == "") {
                settingCaretDefaultValue = 2;
            }

            settingCaretMinValue = parseFloat(settingCaretMinValue);
            settingCaretMaxValue = parseFloat(settingCaretMaxValue);
            settingCaretSteperValue = parseFloat(settingCaretSteperValue);
            settingCaretDefaultValue = parseFloat(settingCaretDefaultValue);
        }
    });

    tabHeaderHtml += `
        <div class="vdb-step continue_diamond_section ${activeStep == 'diamond_selection' ? "vdb-step-active" : ""}" data-step="diamond_selection">
            <span class="vdb-step-label">${count}. Diamond Selection</span>
        </div>`;

    tabHeaderHtml += `
        <div class="d-none vdb-step ${activeStep == 'review' ? "vdb-step-active" : ""}" data-step="review" style="display: none !important;">
            <span class="vdb-step-label">Review</span>
        </div>`;
    /* tabHeaderHtml += `
        <div class="d-none vdb-step" data-step="add_to_cart">
            <span class="vdb-step-label">Add to Cart</span>
        </div>`; */

    tabHeaderHtml += tabNextBtnHtml;
    $("#vdbrb_setting_option_tab").html(tabHeaderHtml);
    $("#vdbrb_setting_option_tab_data").html(html);
};
const fetchProductRelatedAllData = async () => {
    const settings = {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            action: "fetch_all_data_for_webgi",
            shop: shop,
            product_handle: $("#vdbrb_setting_hdn_prod_handle").val(),
        }),
    };
    try {
        const fetchResponse = await fetch(API_URL, settings);
        if (!fetchResponse.ok) {
            throw new Error(`HTTP error! Status: ${fetchResponse.status}`);
        }
        const data = await fetchResponse.json();
        return data;
    } catch (error) {
        return error;
    }
};
const fetchProductRelatedAllDataBasedOnAttr = async (selectedAttributeData, selectedItemObj) => {
    const settings = {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            action: "fetch_all_data_for_webgi_based_on_attr",
            shop: shop,
            product_handle: $("#vdbrb_setting_hdn_prod_handle").val(),
            configurator_name: $("#vdbrb_setting_hdn_configurator_name").val(),
            attribute_info: selectedAttributeData,
            selected_attribute_info: selectedItemObj,
        }),
    };
    try {
        const fetchResponse = await fetch(API_URL, settings);
        if (!fetchResponse.ok) {
            throw new Error(`HTTP error! Status: ${fetchResponse.status}`);
        }
        const data = await fetchResponse.json();
        return data;
    } catch (error) {
        return error;
    }
};
async function fetchData() {
    // $("#product_details_cover").show();
    $(".vdbrb_add_to_cart_btn").attr("disabled", true);
    const webgiProdInfo = await fetchProductRelatedAllData();
    if (webgiProdInfo?.SUCCESS == "TRUE") {
        await generalProcessAfterFetchData(webgiProdInfo);
        $("#vdbrb_filter_block_loader").fadeOut(200);
        handleThreeDPart(webgiProdInfo?.DATA);
        handleCompatibleStoneShape(webgiProdInfo?.DATA?.compatible_stone_shape);
    } else {
        console.log("Data not found");
    }
    setTimeout(function () {
        // $("#product_details_cover").hide();
        $(".vdbrb_add_to_cart_btn").removeAttr("disabled");
    }, 1500);
}

function convertToSlug(text) {
    return text.toLowerCase() // Convert to lowercase
        .replace(/ /g, "_") // Replace spaces with hyphens
        .replace(/[^\w-]+/g, "") // Remove all non-word chars except hyphens
        .replace(/--+/g, "-") // Replace multiple hyphens with single hyphen
        .replace(/^-+/, "") // Trim hyphens from start of text
        .replace(/-+$/, ""); // Trim hyphens from end of text
}
//#endregion

//#region : ThreeD Functions
async function handleThreeDPart(productData, isUpdate = false) {
    if (Object.keys(productData).length > 0) {
        const headUrl = productData?.head_glb_url;
        const shankUrl = productData?.shank_glb_url;

        let selectedMetalColorVal = $('.lineitem_prop[data-main-option-slug="metal_metal_color"]').data('sub-option-slug');
        selectedMetalColorVal = selectedMetalColorVal.toLowerCase();

        let metalHeadColor = 'white_gold';
        let metalShankColor = 'white_gold';
        if (selectedMetalColorVal.includes('rose')) {
            metalHeadColor = 'rose_gold';
            metalShankColor = 'rose_gold';
        } else if (selectedMetalColorVal.includes('yellow')) {
            metalHeadColor = 'yellow_gold';
            metalShankColor = 'yellow_gold';
        } else if (selectedMetalColorVal.includes('two-tone')) {
            metalHeadColor = 'white_gold';
            metalShankColor = 'yellow_gold';
        }

        const metalHead = three_d_static_data[0]['pmat'][metalHeadColor];
        const metalShank = three_d_static_data[0]['pmat'][metalShankColor];

        let selectedShapeSlugVal = $('.lineitem_prop[data-main-option-slug="stone_shape"]').attr('data-sub-option-slug');
        const dmatFile = three_d_static_data[0]['dmat'][selectedShapeSlugVal];

        let three_d_media_arr = generateThreeDMediaArray(headUrl, shankUrl, metalHead, metalShank, dmatFile);
        if (three_d_media_arr.length > 0) {
            if (isUpdate) {
                window.player.update(canvasId, three_d_media_arr);
            } else {
                window.player.init(canvasId, three_d_media_arr);
            }
        }
    }
}
function generateThreeDMediaArray(head, shank, metal_head, metal_shank, dmat) {
    let three_d_media = [
        {
            "option_type": "model",
            "option_value": head,
            "option_identifier": "head"
        },
        {
            "option_type": "model",
            "option_value": shank,
            "option_identifier": "shank"
        },
        {
            "option_type": "material",
            "option_value": metal_head,
            "option_identifier": "metal-head"
        },
        {
            "option_type": "material",
            "option_value": metal_shank,
            "option_identifier": "metal-shank"
        },
        {
            "option_type": "material",
            "option_value": dmat,
            "option_identifier": "shankaccent-round,bandaccent-round,hiddenhalo-round,mainstone-round,mainstone-oval,mainstone-ovel,mainstone-pear,mainstone-princess,mainstone-asscher,mainstone-cushion,mainstone-elongated cushion,mainstone-emerald,mainstone-heart,mainstone-marquise,mainstone-radiant,collarhalo-round,sidestone-baguette,sidestone-trillion,sidestone-baguette,sidestone-pear,sidestone-oval,sidestone-emerald"
        }
    ];

    return three_d_media;
}
//#endregion

function handleReviewPageBlock(state = 'hide') {
    console.log('handleReviewPageBlock', state);    
    if (state = 'show') {
        $("#vdbrb_review_module").removeClass("d-none");
        $("#vdbrb_design_ring_module").removeClass("d-none");
        $("#vdbrb_review_page_details_right_container").removeClass("d-none");
        $("#vdbrb_design_ring_tab_filter_right_container").addClass("d-none");

        $('#vdbrb_setting_option_tab .vdb-step').removeClass("vdb-step-active");
        $('#vdbrb_setting_option_tab .vdb-step[data-step="review"]').removeClass("d-none").addClass("vdb-step-active");

        $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_atc_btn').removeClass("d-none");
        $('#vdbrb_setting_option_tab .vdb-next-btn .vdb_review_btn').addClass("d-none");
        $('#vdbrb_setting_option_tab .vdb-next-btn').addClass("text_btn");

        setTimeout(function () {
            window.player.changeCameraAngle(-1.6771501393444994, 2.8990532558344957, 0.023036595467960226);
            window.player.changeAutoRotate(true);
        }, 2000);

    }
}

$("body").on("click", ".vdb-sidemenu-toggle-btn", function () {
    $(this).toggleClass("active");
    $(".vdb-sidemenu-wrapper").toggleClass("show-sidemenu-bar");
});

function scrollTillSelectedDiamond() {
    const tabView = $('#vdbrb_view_dropdown').val();
    if (tabView == 'LIST_VIEW') {
        const activeRow = $('#vdbrb_stone_list_view_block .vdb_rb_list_row_tr.vdb_gd_data_tr_active');

        if (activeRow.length) {
            $('html, body').animate({
                scrollTop: activeRow.offset().top - 125
            }, 100); // Smooth scrolling in 500ms
        }
    }
}
function isMobileDevice() {
    return /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);
}

// Review step Ring & Diamond details collaps function
$(document).ready(function () {
    $(".vdb-rc-accordion-heading").click(function () {
        if ($(this).next(".vdb-rc-accordion-content").is(":visible")) {
            $(this).next(".vdb-rc-accordion-content").hide();
            $(this).removeClass("active");
        } else {
            $(".vdb-rc-accordion-content").hide();
            $(".vdb-rc-accordion-heading").removeClass("active");
            $(this).next(".vdb-rc-accordion-content").show();
            $(this).addClass("active");
        }
    });
});

const items = document.querySelectorAll('.vdb-sidemenu-list');
items.forEach(el => {
    el.addEventListener('mouseenter', () => showTip(el, true));
    el.addEventListener('mouseleave', () => showTip(el, false));
    /* el.addEventListener('touchstart', e => {
        e.preventDefault();
        showTip(el, true);
        document.addEventListener('touchstart', onDocTouch);
        function onDocTouch(ev) {
            if (!el.contains(ev.target)) {
                showTip(el, false);
                document.removeEventListener('touchstart', onDocTouch);
            }
        }
    }); */
});

function showTip(el, on) {
    if (window.matchMedia('(min-width: 1024px)').matches) {
        const tip = el.querySelector('.tooltip');
        if (!tip) return;

        if (on) {
            tip.style.opacity = '1';
            tip.style.visibility = 'visible';
            tip.style.transform = 'scale(1)';
        } else {
            tip.style.opacity = '0';
            tip.style.visibility = 'hidden';
            tip.style.transform = 'scale(0.8)';
        }
    }
}

function closeDropdown() {
    const dropdownMenu = $('.vdb-shape-main-box .vdb-custom-dropdown');
    const arrowIcon = $('.arrowIcon');
    const dropdownToggle = $('.vdb-shap-componet .vdb-edit-toggle');

    dropdownMenu.hide();
    arrowIcon.removeClass('open');
    dropdownToggle.removeClass('active');
}
function openDropdown() {
    const dropdownMenu = $('.vdb-shape-main-box .vdb-custom-dropdown');
    const arrowIcon = $('.arrowIcon');
    const dropdownToggle = $('.vdb-shap-componet .vdb-edit-toggle');

    dropdownMenu.show();
    arrowIcon.addClass('open');
    dropdownToggle.addClass('active');
}
function toggleDropdown() {
    const dropdownMenu = $('.vdb-shape-main-box .vdb-custom-dropdown');

    if (dropdownMenu.is(':visible')) {
        closeDropdown();
    } else {
        openDropdown();
    }
}
// Toggle dropdown on button click
$("body").on("click", '.vdb-shap-componet .vdb-edit-toggle', function (e) {
    e.stopPropagation();
    toggleDropdown();
});
// Handle item selection
$("body").on("click", '.vdb-shape-main-box .vdb-custom-dropdown li', function () {
    const items = $('.vdb-shape-main-box .vdb-custom-dropdown li');
    const selectedValue = $('.selectedValue');

    items.removeClass('vdb-selected');
    $(this).addClass('vdb-selected');
    selectedValue.text($(this).text());
    closeDropdown();
});
// Close dropdown on outside click
$("body").on("click", function (e) {
    if (!$(e.target).closest('.vdb-dropdown-container').length) {
        closeDropdown();
    }
});

// Custom Tabs
$(document).ready(function () {
    const tabs = document.querySelectorAll('.vdb-tab');
    const contents = {
        expert: document.getElementById('vdb-content-expert'),
        payment: document.getElementById('vdb-content-payment'),
        share_ring: document.getElementById('vdb-content-share_ring'),
        hint: document.getElementById('vdb-content-hint')
    };

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            // Remove active state from all tabs
            tabs.forEach(t => t.classList.remove('vdb-active'));
            tab.classList.add('vdb-active');

            // Hide all content sections
            Object.values(contents).forEach(c => c.style.display = 'none');

            // Show selected content
            contents[tab.dataset.tab].style.display = 'block';
        });
    });
});